
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cgy29", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $aWwYt = parcelRequire("aWwYt");


var $cMvMc = parcelRequire("cMvMc");


var $9jl6v = parcelRequire("9jl6v");


var $bSvtO = parcelRequire("bSvtO");


var $brNvA = parcelRequire("brNvA");


var $cZa7r = parcelRequire("cZa7r");


var $4DJgG = parcelRequire("4DJgG");

const $dacb5f0322f4a333$export$5ae138a5a05281f1 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { contentId: contentId, isFabric: isFabric, sendKeyboardShortcutAnalytics: sendKeyboardShortcutAnalytics } = t0;
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { setSelectionOptionsForCreateEditor: setSelectionOptionsForCreateEditor } = (0, $cZa7r.useAnnotationsDispatch)();
    const { createComment: createComment } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const { commentToReattach: commentToReattach } = (0, $brNvA.useReattachComment)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const content = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            content.current = document.querySelector("div#content");
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[2] !== commentToReattach || $[3] !== contentId || $[4] !== createComment || $[5] !== hideObjectSidebar || $[6] !== isFabric || $[7] !== isObjectSidebarShown || $[8] !== setSelectionOptionsForCreateEditor) {
        t3 = (t4)=>{
            const { experienceAttributes: experienceAttributes } = t4 === undefined ? {} : t4;
            if (isObjectSidebarShown) hideObjectSidebar();
            if (isFabric) setSelectionOptionsForCreateEditor({
                experienceAttributes: experienceAttributes
            });
            else if (content.current) createComment((0, $4DJgG.getLegacyConvertedSelectionObj)({
                content: content,
                contentId: contentId,
                commentToReattach: commentToReattach
            }));
        };
        $[2] = commentToReattach;
        $[3] = contentId;
        $[4] = createComment;
        $[5] = hideObjectSidebar;
        $[6] = isFabric;
        $[7] = isObjectSidebarShown;
        $[8] = setSelectionOptionsForCreateEditor;
        $[9] = t3;
    } else t3 = $[9];
    const createReactInlineCommentHighlight = t3;
    let t4;
    if ($[10] !== createReactInlineCommentHighlight || $[11] !== hasContentChanged || $[12] !== sendKeyboardShortcutAnalytics) {
        const handleCommentButtonClick = (t5)=>{
            const { dialogs: dialogs, shortcut: shortcut, experienceAttributes: experienceAttributes_0 } = t5;
            if (hasContentChanged) dialogs.showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>createReactInlineCommentHighlight({
                        experienceAttributes: experienceAttributes_0
                    })
            });
            else createReactInlineCommentHighlight({
                experienceAttributes: experienceAttributes_0
            });
            if (shortcut) sendKeyboardShortcutAnalytics(shortcut);
        };
        t4 = {
            handleCommentButtonClick: handleCommentButtonClick
        };
        $[10] = createReactInlineCommentHighlight;
        $[11] = hasContentChanged;
        $[12] = sendKeyboardShortcutAnalytics;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
} : ({ contentId: contentId, isFabric: isFabric, sendKeyboardShortcutAnalytics: sendKeyboardShortcutAnalytics })=>{
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { setSelectionOptionsForCreateEditor: setSelectionOptionsForCreateEditor } = (0, $cZa7r.useAnnotationsDispatch)();
    const { createComment: createComment } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const { commentToReattach: commentToReattach } = (0, $brNvA.useReattachComment)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const content = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        content.current = document.querySelector('div#content');
    }, []);
    const createReactInlineCommentHighlight = ({ experienceAttributes: experienceAttributes } = {})=>{
        if (isObjectSidebarShown) hideObjectSidebar();
        if (isFabric) setSelectionOptionsForCreateEditor({
            experienceAttributes: experienceAttributes
        });
        else if (content.current) createComment((0, $4DJgG.getLegacyConvertedSelectionObj)({
            content: content,
            contentId: contentId,
            commentToReattach: commentToReattach
        }));
    };
    const handleCommentButtonClick = ({ dialogs: dialogs, shortcut: shortcut, experienceAttributes: experienceAttributes_0 })=>{
        if (hasContentChanged) dialogs.showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>createReactInlineCommentHighlight({
                    experienceAttributes: experienceAttributes_0
                })
        });
        else createReactInlineCommentHighlight({
            experienceAttributes: experienceAttributes_0
        });
        if (shortcut) sendKeyboardShortcutAnalytics(shortcut);
    };
    return {
        handleCommentButtonClick: handleCommentButtonClick
    };
};
module.exports["useCreateCommentAction"] = $dacb5f0322f4a333$export$5ae138a5a05281f1;

});

parcelRegister("izhdc", function(module, exports) {

var $8i27m = parcelRequire("8i27m");

const $fd72c77cd5bf52d0$export$8a92cb9a88bcfd3b = (currentlyRenderedThreads, unresolvedInlineComments)=>{
    // Grab everything on the screen as a set for quick access
    const allRenderedInlineCommentIds = new Set(unresolvedInlineComments);
    // Grab all of the refs for inline comments that are available on the panel
    const panelCommentRefs = currentlyRenderedThreads.map((comment)=>{
        if (comment.type === 'INLINE') {
            if ('inlineMarkerRef' in comment && comment.inlineMarkerRef) return {
                ref: comment.inlineMarkerRef,
                type: (0, $8i27m.CommentType).INLINE
            };
            else return {
                ref: '',
                type: (0, $8i27m.CommentType).INLINE
            };
        } else return {
            ref: comment.id,
            type: (0, $8i27m.CommentType).GENERAL
        };
    }).filter((comment)=>{
        return comment.ref !== '';
    });
    // Grab the refs that we can navigate too (aka the ones rendered on the page, so open (i.e. not resolved) comments)
    const navigableInlineCommentRefs = new Set(panelCommentRefs.map((comment)=>{
        if (comment.type === (0, $8i27m.CommentType).INLINE) return allRenderedInlineCommentIds.has(comment.ref) ? comment.ref : '';
        else return comment.ref;
    }));
    return {
        panelCommentRefs: panelCommentRefs,
        navigableInlineCommentRefs: navigableInlineCommentRefs
    };
};
const $fd72c77cd5bf52d0$export$6fbaa3cb5c58ff29 = (action, panelCommentRefs, currentlySelectedThreadKey)=>{
    let nextIndex = panelCommentRefs.findIndex((comment)=>{
        return comment.ref === currentlySelectedThreadKey;
    });
    if (nextIndex === -1) nextIndex = 0;
    else if (action === 'next') nextIndex = (nextIndex + 1) % panelCommentRefs.length;
    else nextIndex = (nextIndex - 1 + panelCommentRefs.length) % panelCommentRefs.length;
    return panelCommentRefs[nextIndex];
};
module.exports["parsePanelAndInlineRefs"] = $fd72c77cd5bf52d0$export$8a92cb9a88bcfd3b;
module.exports["getNextRef"] = $fd72c77cd5bf52d0$export$6fbaa3cb5c58ff29;

});

parcelRegister("gSkOQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $aSsfA = parcelRequire("aSsfA");


var $6lAIr = parcelRequire("6lAIr");


var $i6UMJ = parcelRequire("i6UMJ");


var $8i27m = parcelRequire("8i27m");


var $4L9ve = parcelRequire("4L9ve");


var $6mKj3 = parcelRequire("6mKj3");

const $89de80864b4e19fe$export$618f651f678380bf = ()=>{
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, commentsDataMap: legacyCommentsDataMap } = (0, $8i27m.useCommentsDataState)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    const commentsDataMap = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? processedCommentsData.commentsDataMap : legacyCommentsDataMap;
    return (0, $cozmU.useMemo)(()=>{
        const footerCommentThreads = (0, $6lAIr.getVisibleCommentThreads)({
            includeGeneralComments: true,
            commentsDataMap: commentsDataMap,
            includeInlineComments: false,
            orderedAnnotationIds: (0, $i6UMJ.getAnnotationThreadKeys)(orderedActiveAnnotationIdList),
            pageMode: pageMode
        });
        const footerCommentIds = footerCommentThreads.map((thread)=>thread.id);
        return {
            footerCommentIds: footerCommentIds,
            footerCommentThreads: footerCommentThreads
        };
    }, [
        commentsDataMap,
        orderedActiveAnnotationIdList,
        pageMode
    ]);
};
module.exports["useFooterComments"] = $89de80864b4e19fe$export$618f651f678380bf;

});

parcelRegister("iNYtG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4r9Ir = parcelRequire("4r9Ir");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $bQm3c = parcelRequire("bQm3c");


var $6UYek = parcelRequire("6UYek");


var $8i27m = parcelRequire("8i27m");


var $3mVfX = parcelRequire("3mVfX");


var $dkkKv = parcelRequire("dkkKv");


var $l5y3Y = parcelRequire("l5y3Y");


var $fHAwL = parcelRequire("fHAwL");


var $d3bcC = parcelRequire("d3bcC");


var $6mKj3 = parcelRequire("6mKj3");


var $NYiei = parcelRequire("NYiei");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $804Ue = parcelRequire("804Ue");


var $83eLG = parcelRequire("83eLG");


var $aM1he = parcelRequire("aM1he");

const $d9d12cfcf38f06b2$export$ae25147d30bdeffa = ({ contentId: contentId, contentType: contentType })=>{
    const isReactionsEnabled = (0, $l5y3Y.useIsReactionsEnabled)(contentId);
    const { addNewComment: addNewComment, removeComment: removeComment, clearNewComments: clearNewComments } = (0, $cozmU.useContext)((0, $4r9Ir.NewCommentsContext));
    const { addSubscriber: addSubscriber, removeSubscriber: removeSubscriber, setContentType: setContentType, setContentId: setContentId } = (0, $6UYek.useSubscriptionsDispatchContext)() || {};
    const subscriptions = (0, $cozmU.useRef)([]);
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { updateUnreadCommentIDSet: updateUnreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsActions)();
    const { getViewedCommentsCacheOnly: getViewedCommentsCacheOnly } = (0, $d3bcC.useViewedComments)({
        pageId: contentId
    });
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { addReplyToCommentThread: addReplyToCommentThread, addNewCommentThreads: addNewCommentThreads, getCurrentCommentsPanelState: getCurrentCommentsPanelState, updateCommentBody: updateCommentBody, updateRemovedCommentIdsMap: updateRemovedCommentIdsMap, reopenParentComment: reopenParentComment } = (0, $8i27m.useCommentsDataActions)();
    const { setReplyToCommentId: setReplyToCommentId, getCommentsPanelState: getCommentsPanelState } = (0, $3mVfX.useCommentsPanelActions)();
    const clearReplyIfRemoved = (0, $cozmU.useCallback)(({ commentId: commentId })=>{
        const { replyToCommentId: replyToCommentId } = getCommentsPanelState();
        if (replyToCommentId === commentId) setReplyToCommentId();
    }, [
        getCommentsPanelState,
        setReplyToCommentId
    ]);
    // Control skip state - start with true to prevent query on mount, set to false when events are detected
    const [shouldSkipQuery, setShouldSkipQuery] = (0, $cozmU.useState)(true);
    // Reset skip state when contentId changes (new page)
    (0, $cozmU.useEffect)(()=>{
        setShouldSkipQuery(true);
    }, [
        contentId
    ]);
    const { deleteCommentInCache: deleteCommentInCache, addCommentInCache: addCommentInCache } = (0, $NYiei.useAllCommentsData)({
        contentId: contentId,
        options: {
            skip: true // Only using write operations, no need to fetch data
        }
    });
    // Implementation using ActiveCommentsQuery
    // Skip is controlled by state - starts as true, set to false when handleEventFetchSuccess is called
    const { refetch: activeCommentsRefetch } = (0, $dkkKv.useActiveCommentsQuery)({
        pageId: contentId,
        type: 'FOOTER',
        skip: shouldSkipQuery || !contentId,
        fetchPolicy: 'cache-and-network'
    });
    const subscribeToPageCommentsPubSub = (0, $cozmU.useCallback)(()=>{
        // Early return if pageMode is Edit - do not setup pubsub for edit pages
        if (pageMode === (0, $cD1qu.PageMode).EDIT) return;
        if (subscriptions.current.length > 0 && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return;
        const queryArgs = {
            isReactionsEnabled: isReactionsEnabled
        };
        subscriptions.current = (0, $83eLG.setUpPageCommentsPubSub)({
            contentId: contentId,
            contentType: contentType,
            userId: userId,
            reloader: activeCommentsRefetch,
            addNewComment: addNewComment,
            removeComment: removeComment,
            queryArgs: queryArgs,
            addNewCommentThreads: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? ()=>{} : addNewCommentThreads,
            addReplyToCommentThread: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? ()=>{} : addReplyToCommentThread,
            updateCommentBody: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? ()=>{} : updateCommentBody,
            updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
            reopenParentComment: reopenParentComment,
            getCurrentCommentsPanelState: getCurrentCommentsPanelState,
            addSubscriber: addSubscriber,
            setContentType: setContentType,
            setContentId: setContentId,
            updateUnreadCommentIDSet: updateUnreadCommentIDSet,
            getViewedCommentsCacheOnly: getViewedCommentsCacheOnly,
            addCommentInCache: addCommentInCache,
            deleteCommentInCache: deleteCommentInCache,
            clearReplyIfRemoved: clearReplyIfRemoved
        }) ?? [];
    }, [
        contentId,
        contentType,
        userId,
        activeCommentsRefetch,
        addNewComment,
        removeComment,
        isReactionsEnabled,
        addNewCommentThreads,
        addReplyToCommentThread,
        updateCommentBody,
        updateRemovedCommentIdsMap,
        reopenParentComment,
        getCurrentCommentsPanelState,
        addSubscriber,
        setContentType,
        setContentId,
        updateUnreadCommentIDSet,
        getViewedCommentsCacheOnly,
        addCommentInCache,
        deleteCommentInCache,
        pageMode,
        clearReplyIfRemoved
    ]);
    const unsubscribeFromPageCommentsPubSub = (0, $cozmU.useCallback)(()=>{
        // Early return if pageMode is Edit - no pubsub was set up for edit pages
        if (pageMode === (0, $cD1qu.PageMode).EDIT) return;
        if (subscriptions.current.length === 0 && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return;
        const queryArgs_0 = {
            isReactionsEnabled: isReactionsEnabled
        };
        (0, $83eLG.removePageCommentsPubSub)({
            contentId: contentId,
            contentType: contentType,
            userId: userId,
            reloader: activeCommentsRefetch,
            addNewComment: addNewComment,
            removeComment: removeComment,
            queryArgs: queryArgs_0,
            updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
            removeSubscriber: removeSubscriber,
            subscriptions: subscriptions.current,
            getViewedCommentsCacheOnly: getViewedCommentsCacheOnly
        });
        if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) subscriptions.current = [];
    }, [
        contentId,
        contentType,
        userId,
        activeCommentsRefetch,
        addNewComment,
        removeComment,
        isReactionsEnabled,
        updateRemovedCommentIdsMap,
        removeSubscriber,
        getViewedCommentsCacheOnly,
        pageMode
    ]);
    const handleEventFetchSuccess = (0, $cozmU.useCallback)((data)=>{
        if (data && data.contentId === contentId) {
            // Enable the query so refetch can work
            setShouldSkipQuery(false);
            if (data.commentEvents.length) {
                const commentData = data.commentEvents.map((event)=>{
                    return {
                        commentId: event.id,
                        accountId: event.accountId
                    };
                });
                (0, $aM1he.reloadAndAddPageComments)(activeCommentsRefetch, addNewComment, commentData, userId);
            }
        }
    }, [
        contentId,
        addNewComment,
        activeCommentsRefetch,
        userId
    ]);
    if (!userId || pageMode === (0, $cD1qu.PageMode).EDIT && (0, $6mKj3.expValEquals)('confluence_comments_get_document_version_number', 'isEnabled', true)) return null;
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).COLLABORATION
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $804Ue.MissedPubSubCommentEventsHandler), {
        contentId: contentId,
        eventType: (0, $804Ue.CommentEventType).FOOTER,
        subscribeToPubSubEvents: subscribeToPageCommentsPubSub,
        unsubscribeFromPubSubEvents: unsubscribeFromPageCommentsPubSub,
        onEventFetchSuccess: handleEventFetchSuccess,
        onDocumentReturn: clearNewComments,
        isAutoReloadPageComments: true
    }));
};
module.exports["PageCommentsPubSubHandler"] = $d9d12cfcf38f06b2$export$ae25147d30bdeffa;

});

parcelRegister("83eLG", function(module, exports) {

var $7S9uM = parcelRequire("7S9uM");


var $gRrX4 = parcelRequire("gRrX4");


var $8i27m = parcelRequire("8i27m");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $kQekh = parcelRequire("kQekh");


var $jLcXM = parcelRequire("jLcXM");


var $e4kZB = parcelRequire("e4kZB");


var $lb2Lp = parcelRequire("lb2Lp");


var $c0rhi = parcelRequire("c0rhi");


var $b11gn = parcelRequire("b11gn");


var $2QXMk = parcelRequire("2QXMk");


var $aM1he = parcelRequire("aM1he");

const $ced40be9017d58cb$var$FETCH_COMMENT_RETRY_DELAYS_MS = [
    500,
    1000,
    2000
];
/**
 * Fetches a comment by ID with automatic retry on null result.
 * The pubsub event can arrive before the server has committed the comment,
 * causing fetchCommentById to return null. We retry with backoff to handle this.
 */ const $ced40be9017d58cb$var$fetchCommentByIdWithRetry = async ({ commentId: commentId, contentId: contentId })=>{
    let result = await (0, $lb2Lp.fetchCommentById)({
        commentId: commentId,
        contentId: contentId,
        fetchPolicy: 'network-only'
    });
    if (result !== null) return result;
    for (const delayMs of $ced40be9017d58cb$var$FETCH_COMMENT_RETRY_DELAYS_MS){
        // eslint-disable-next-line no-await-in-loop
        await new Promise((resolve)=>setTimeout(resolve, delayMs));
        // eslint-disable-next-line no-await-in-loop
        result = await (0, $lb2Lp.fetchCommentById)({
            commentId: commentId,
            contentId: contentId,
            fetchPolicy: 'network-only'
        });
        if (result !== null) return result;
    }
    return result;
};
const $ced40be9017d58cb$export$66752be9311cfe87 = async (contentId, commentId)=>{
    const queryVariables = {
        commentId: commentId,
        contentId: contentId
    };
    const commentDataResult = await (0, $c0rhi.queryInterop)({
        query: (0, $kQekh.CommentsSectionGetSingleCommentQuery),
        fetchPolicy: 'network-only',
        variables: queryVariables,
        __callerPackage__: "comments-pubsub"
    });
    return commentDataResult.data;
};
const $ced40be9017d58cb$export$e02e3f365960f15 = async (contentId, commentId)=>{
    const queryVariables = {
        commentId: commentId,
        contentId: contentId
    };
    const commentDataResult = await (0, $c0rhi.queryInterop)({
        query: (0, $jLcXM.ActivePageCommentQuery),
        fetchPolicy: 'network-only',
        variables: queryVariables,
        __callerPackage__: "comments-pubsub"
    });
    return commentDataResult.data;
};
const $ced40be9017d58cb$export$37a9d770052438a6 = async ({ commentId: commentId, contentId: contentId, addNewCommentThreads: addNewCommentThreads, addReplyToCommentThread: addReplyToCommentThread })=>{
    const commentThreadDataResult = await $ced40be9017d58cb$export$66752be9311cfe87(contentId, commentId ?? '');
    const comment = commentThreadDataResult?.comments?.nodes?.[0];
    if (comment) {
        const createdAt = comment.version.when;
        const commentLocation = comment.location;
        // Parent comment case
        if (!comment.parentId) addNewCommentThreads && addNewCommentThreads({
            general: {
                [comment.id]: {
                    ...comment,
                    isOpen: true,
                    wasRemovedByAnotherUser: false,
                    type: (0, $8i27m.CommentType).GENERAL,
                    replies: [],
                    // Newly created comments will never have replies
                    contributors: comment.contributors ?? [],
                    createdAt: {
                        value: createdAt
                    },
                    location: {
                        type: 'FOOTER',
                        commentResolveProperties: commentLocation.commentResolveProperties
                    },
                    links: {
                        webui: comment.links.webui,
                        editui: null
                    },
                    permissions: {
                        isEditable: comment.permissions.isEditable,
                        isRemovable: comment.permissions.isRemovable,
                        isResolvable: true
                    }
                }
            },
            inline: {}
        });
        else {
            const threadKey = comment.ancestors[comment.ancestors.length - 1]?.id ?? comment.id;
            addReplyToCommentThread && addReplyToCommentThread(threadKey, {
                ...comment,
                isOpen: true,
                wasRemovedByAnotherUser: false,
                type: (0, $8i27m.CommentType).GENERAL,
                createdAt: {
                    value: createdAt
                },
                location: {
                    type: 'FOOTER',
                    commentResolveProperties: commentLocation.commentResolveProperties
                },
                links: {
                    webui: comment.links.webui,
                    editui: null
                },
                permissions: {
                    isEditable: comment.permissions.isEditable,
                    isRemovable: comment.permissions.isRemovable,
                    isResolvable: true
                }
            }, (0, $8i27m.CommentType).GENERAL);
        }
    }
};
const $ced40be9017d58cb$export$9cc4fc7c59ab4b10 = async ({ commentId: commentId, contentId: contentId, updateCommentBody: updateCommentBody })=>{
    const commentThreadDataResult = await $ced40be9017d58cb$export$66752be9311cfe87(contentId, commentId ?? '');
    const comment = commentThreadDataResult?.comments?.nodes?.[0];
    if (comment) {
        const threadKey = comment.ancestors[comment.ancestors.length - 1]?.id ?? comment.id;
        updateCommentBody && updateCommentBody(comment.id, threadKey, comment.body.value, (0, $8i27m.CommentType).GENERAL, comment.version?.by?.displayName);
    }
};
const $ced40be9017d58cb$export$4d3ff641e060619d = async ({ commentId: commentId, contentId: contentId, updateRemovedCommentIdsMap: updateRemovedCommentIdsMap })=>{
    const commentThreadDataResult = await $ced40be9017d58cb$export$66752be9311cfe87(contentId, commentId ?? '');
    const comment = commentThreadDataResult?.comments?.nodes?.[0];
    if (comment && // @ts-expect-error
    comment.location.__typename === 'FooterComment' && comment.location.commentResolveProperties) updateRemovedCommentIdsMap && updateRemovedCommentIdsMap({
        threadKey: comment.id,
        commentId: comment.id,
        commentActionType: (0, $8i27m.CommentActionType).RESOLVE_COMMENT_THREAD,
        isReply: !!comment.parentId,
        commentType: (0, $8i27m.CommentType).GENERAL,
        resolvedProperties: comment.location.commentResolveProperties
    });
    else if (comment) updateRemovedCommentIdsMap && updateRemovedCommentIdsMap({
        threadKey: comment.id,
        commentId: comment.id,
        commentActionType: (0, $8i27m.CommentActionType).RESOLVE_COMMENT_THREAD,
        isReply: !!comment.parentId,
        commentType: (0, $8i27m.CommentType).GENERAL
    });
};
const $ced40be9017d58cb$export$bbee85055c5ba3c6 = async ({ commentId: commentId, contentId: contentId, addNewCommentThreads: addNewCommentThreads, getCurrentCommentsPanelState: getCurrentCommentsPanelState })=>{
    if (!getCurrentCommentsPanelState) return;
    const { commentsDataMap: commentsDataMap } = getCurrentCommentsPanelState();
    // Use the new ActivePageCommentQuery
    const commentThreadDataResult = await $ced40be9017d58cb$export$e02e3f365960f15(contentId, commentId ?? '');
    const comment = commentThreadDataResult?.comments?.nodes?.[0];
    if (comment && commentsDataMap) {
        const commentsDataMapClone = {
            ...commentsDataMap
        };
        const commentInMap = commentsDataMapClone[(0, $8i27m.CommentType).GENERAL][comment.id];
        if (commentInMap) {
            commentInMap.isOpen = true;
            commentInMap.wasRemovedByAnotherUser = false;
            addNewCommentThreads && addNewCommentThreads(commentsDataMapClone);
        }
    }
    return comment;
};
const $ced40be9017d58cb$var$handleUnreadCommentsForReopenedComment = ({ comment: comment, userId: userId, viewedComments: viewedComments, updateUnreadCommentIDSet: updateUnreadCommentIDSet })=>{
    const validUnreadCommentIds = new Set();
    // Validate the main comment
    const commentForValidation = (0, $e4kZB.buildValidationObjectFromProps)({
        commentId: comment.id,
        userId: comment.author?.__typename === 'KnownUser' ? comment.author.accountId : undefined,
        createdAt: comment.createdAt?.value || undefined,
        commentType: 'FOOTER',
        // Page comments are always FOOTER type
        resolveProperties: {
            resolved: false
        } // reopened comment = resolved false
    });
    if ((0, $e4kZB.isValidUnreadComment)({
        comment: commentForValidation,
        currentUserId: userId,
        viewedComments: viewedComments
    })) validUnreadCommentIds.add(comment.id);
    // Validate replies if they exist
    if (comment.replies) comment.replies.forEach((reply)=>{
        const replyForValidation = (0, $e4kZB.buildValidationObjectFromProps)({
            commentId: reply.id,
            userId: reply.author?.__typename === 'KnownUser' ? reply.author.accountId : undefined,
            createdAt: reply.createdAt?.value || undefined,
            commentType: 'FOOTER',
            // Page comments are always FOOTER type
            resolveProperties: {
                resolved: false
            } // reopened comment = resolved false
        });
        if ((0, $e4kZB.isValidUnreadComment)({
            comment: replyForValidation,
            currentUserId: userId,
            viewedComments: viewedComments
        })) validUnreadCommentIds.add(reply.id);
    });
    updateUnreadCommentIDSet(validUnreadCommentIds, 'add');
};
const $ced40be9017d58cb$export$d4b860510819f61b = async ({ commentId: commentId, updateRemovedCommentIdsMap: updateRemovedCommentIdsMap, getCurrentCommentsPanelState: getCurrentCommentsPanelState })=>{
    if (commentId) {
        // Default to code to delete the top-level comment
        let threadKey = commentId;
        let isReply = false;
        // This should always be true, but if it isn't don't break
        // This case handles removing replies in the panel
        if (getCurrentCommentsPanelState) {
            const { commentsDataMap: commentsDataMap } = getCurrentCommentsPanelState();
            // If the comment is not in the general map, it's a reply
            // That means we need to loop through the flat arrays of replies for each parent comment to find our id
            // It's not fast since it potentially checks every comment on the page, but it's better than a network call
            if (!commentsDataMap[(0, $8i27m.CommentType).GENERAL][commentId]) {
                const allGeneralComments = commentsDataMap[(0, $8i27m.CommentType).GENERAL];
                for (const parentComment of Object.values(allGeneralComments))if (parentComment.replies) {
                    for (const reply of parentComment.replies)if (reply.id === commentId) {
                        threadKey = parentComment.id;
                        isReply = true;
                        break;
                    }
                }
            }
        }
        updateRemovedCommentIdsMap && updateRemovedCommentIdsMap({
            threadKey: threadKey,
            commentId: commentId,
            commentActionType: (0, $8i27m.CommentActionType).DELETE_COMMENT,
            isReply: isReply,
            commentType: (0, $8i27m.CommentType).GENERAL
        });
    }
};
const $ced40be9017d58cb$export$4d067148c1e8c84d = ({ userId: userId, contentId: contentId, reloader: reloader, addNewComment: addNewComment, removeComment: removeComment, updateQueryVariables: updateQueryVariables, addNewCommentThreads: addNewCommentThreads, addReplyToCommentThread: addReplyToCommentThread, updateCommentBody: updateCommentBody, updateRemovedCommentIdsMap: updateRemovedCommentIdsMap, reopenParentComment: reopenParentComment, getCurrentCommentsPanelState: getCurrentCommentsPanelState, getViewedCommentsCacheOnly: getViewedCommentsCacheOnly, updateUnreadCommentIDSet: updateUnreadCommentIDSet, addCommentInCache: addCommentInCache, deleteCommentInCache: deleteCommentInCache, clearReplyIfRemoved: clearReplyIfRemoved })=>(event, payload)=>{
        if (!event) return;
        let commentRequestBody;
        const { accountId: accountId } = payload;
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) commentRequestBody = payload?.[event];
        else commentRequestBody = payload.commentRequestBody;
        const { commentId: commentId } = commentRequestBody;
        const isReply = commentRequestBody?.pageCommentType === 'REPLY';
        // We don't need to respond to events that the current user initiated, unless we need to process their reply.
        if ((0, $2QXMk.shouldSkipOwnPubSubEvent)({
            accountId: accountId,
            currentUserId: userId,
            isReply: isReply,
            isOwnReplyPubSubProcessingEnabled: (0, $6mKj3.expVal)('cc_comments_pubsub_process_own_replies', 'isEnabled', false) && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)
        })) return;
        const { start: startCommentsPubSubExperience, succeed: succeedCommentsPubSubExperience, fail: failCommentsPubSubExperience } = (0, $b11gn.createCommentsPubSubExperienceTracker)((0, $b11gn.CommentsPubSubSource).PageCommentsPubSub);
        startCommentsPubSubExperience(event);
        try {
            switch(event){
                case 'commentCreated':
                case 'avi:confluence:created:comment':
                    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                        if (addCommentInCache && commentId) {
                            const fetchFn = (0, $6mKj3.expVal)('cc_comments_page_comment_retry', 'isEnabled', false) ? $ced40be9017d58cb$var$fetchCommentByIdWithRetry : ({ commentId: cId, contentId: cntId })=>(0, $lb2Lp.fetchCommentById)({
                                    commentId: cId,
                                    contentId: cntId,
                                    fetchPolicy: 'network-only'
                                });
                            fetchFn({
                                commentId: commentId,
                                contentId: contentId
                            }).then((comment)=>{
                                if (comment) {
                                    addCommentInCache({
                                        newComment: comment,
                                        onError: failCommentsPubSubExperience
                                    });
                                    succeedCommentsPubSubExperience();
                                } else failCommentsPubSubExperience(new Error(`commentCreated: comment ${commentId} not found after retries`));
                            }).catch((err)=>{
                                failCommentsPubSubExperience(err);
                            });
                        } else failCommentsPubSubExperience(new Error('commentCreated: addCommentInCache or commentId is not defined'));
                    } else if (!reloader || !addNewComment) failCommentsPubSubExperience(new Error('commentCreated: reloader or addNewComment is not defined'));
                    else Promise.all([
                        $ced40be9017d58cb$export$37a9d770052438a6({
                            commentId: commentId,
                            contentId: contentId,
                            addNewCommentThreads: addNewCommentThreads,
                            addReplyToCommentThread: addReplyToCommentThread
                        }),
                        (0, $aM1he.reloadAndAddPageComments)(reloader, addNewComment, [
                            {
                                commentId: commentId,
                                accountId: accountId
                            }
                        ], userId)
                    ]).then(()=>{
                        succeedCommentsPubSubExperience();
                    }).catch((err)=>{
                        failCommentsPubSubExperience(err);
                    });
                    if (updateUnreadCommentIDSet && accountId !== userId) updateUnreadCommentIDSet(new Set([
                        commentId
                    ]), 'add');
                    break;
                case 'commentResolved':
                case 'avi:confluence:resolved:comment':
                    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                        if (commentId) // fetchCommentById implicitly updates useAllCommentsDataQuery cache
                        (0, $lb2Lp.fetchCommentById)({
                            commentId: commentId,
                            contentId: contentId,
                            fetchPolicy: 'network-only'
                        }).then(()=>{
                            clearReplyIfRemoved?.({
                                commentId: commentId
                            });
                            // Handle unread comments after fetchCommentById completes
                            const { replies: replies = [] } = commentRequestBody;
                            if (updateUnreadCommentIDSet) updateUnreadCommentIDSet(new Set([
                                commentId,
                                ...replies
                            ]), 'remove');
                        }).then(()=>{
                            succeedCommentsPubSubExperience();
                        }).catch((err)=>{
                            failCommentsPubSubExperience(err);
                        });
                        else failCommentsPubSubExperience(new Error('commentResolved: commentId is not defined'));
                        // When cc_comments_new_comments_data_manager is enabled, only commentActionType and commentId are used
                        // The rest of the variables here are defaults
                        if (updateRemovedCommentIdsMap && commentId) updateRemovedCommentIdsMap({
                            threadKey: commentId,
                            commentId: commentId,
                            commentActionType: (0, $8i27m.CommentActionType).RESOLVE_COMMENT_THREAD,
                            isReply: false,
                            commentType: (0, $8i27m.CommentType).GENERAL
                        });
                    } else if (reloader) reloader().then(()=>$ced40be9017d58cb$export$4d3ff641e060619d({
                            commentId: commentId,
                            contentId: contentId,
                            updateRemovedCommentIdsMap: updateRemovedCommentIdsMap
                        }).then(()=>{
                            // Handle unread comments after reloader completes
                            const { replies: replies = [] } = commentRequestBody;
                            if (updateUnreadCommentIDSet) updateUnreadCommentIDSet(new Set([
                                commentId,
                                ...replies
                            ]), 'remove');
                        })).then(()=>{
                        succeedCommentsPubSubExperience();
                    }).catch((err)=>{
                        failCommentsPubSubExperience(err);
                    });
                    else failCommentsPubSubExperience(new Error('commentResolved: reloader is not defined'));
                    break;
                case 'commentDeleted':
                case 'avi:confluence:deleted:comment':
                    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                        if (deleteCommentInCache && commentId) {
                            const deletionSuccessful = deleteCommentInCache({
                                commentId: commentId,
                                onError: failCommentsPubSubExperience
                            });
                            if (deletionSuccessful) clearReplyIfRemoved?.({
                                commentId: commentId
                            });
                        }
                        if (updateUnreadCommentIDSet) updateUnreadCommentIDSet(new Set([
                            commentId
                        ]), 'remove');
                        // When cc_comments_new_comments_data_manager is enabled, only commentActionType and commentId are used
                        // The rest of the variables here are defaults
                        if (updateRemovedCommentIdsMap && commentId) updateRemovedCommentIdsMap({
                            threadKey: commentId,
                            commentId: commentId,
                            commentActionType: (0, $8i27m.CommentActionType).DELETE_COMMENT,
                            isReply: false,
                            commentType: (0, $8i27m.CommentType).GENERAL
                        });
                        succeedCommentsPubSubExperience();
                    } else if (!reloader) failCommentsPubSubExperience(new Error('commentDeleted: reloader is not defined'));
                    else Promise.all([
                        $ced40be9017d58cb$export$d4b860510819f61b({
                            commentId: commentId,
                            updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
                            getCurrentCommentsPanelState: getCurrentCommentsPanelState
                        }),
                        reloader().then(()=>{
                            removeComment && removeComment(commentId);
                            if (updateUnreadCommentIDSet) updateUnreadCommentIDSet(new Set([
                                commentId
                            ]), 'remove');
                        })
                    ]).then(()=>{
                        succeedCommentsPubSubExperience();
                    }).catch((err)=>{
                        failCommentsPubSubExperience(err);
                    });
                    break;
                case 'commentReopened':
                case 'avi:confluence:reopen:comment':
                    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                        if (commentId) // fetchCommentById implicitly updates useAllCommentsDataQuery cache
                        (0, $lb2Lp.fetchCommentById)({
                            commentId: commentId,
                            contentId: contentId,
                            fetchPolicy: 'network-only'
                        }).then((commentData)=>{
                            // Handle unread comments with the fetched comment data
                            if (updateUnreadCommentIDSet && commentData && userId && getViewedCommentsCacheOnly) {
                                const viewedCommentsResult = getViewedCommentsCacheOnly();
                                if (viewedCommentsResult.success && viewedCommentsResult.data) $ced40be9017d58cb$var$handleUnreadCommentsForReopenedComment({
                                    comment: commentData,
                                    userId: userId,
                                    viewedComments: viewedCommentsResult.data,
                                    updateUnreadCommentIDSet: updateUnreadCommentIDSet
                                });
                            }
                        }).then(()=>{
                            succeedCommentsPubSubExperience();
                        }).catch((err)=>{
                            failCommentsPubSubExperience(err);
                        });
                        else failCommentsPubSubExperience(new Error('commentReopened: commentId is not defined'));
                    } else if (reloader) reloader().then(async ()=>{
                        const comment = await $ced40be9017d58cb$export$bbee85055c5ba3c6({
                            commentId: commentId,
                            contentId: contentId,
                            addNewCommentThreads: addNewCommentThreads,
                            getCurrentCommentsPanelState: getCurrentCommentsPanelState
                        });
                        // Handle unread comments with the existing comment data
                        if (updateUnreadCommentIDSet && comment && userId && getViewedCommentsCacheOnly) {
                            const viewedCommentsResult = getViewedCommentsCacheOnly();
                            if (viewedCommentsResult.success && viewedCommentsResult.data) $ced40be9017d58cb$var$handleUnreadCommentsForReopenedComment({
                                comment: comment,
                                userId: userId,
                                viewedComments: viewedCommentsResult.data,
                                updateUnreadCommentIDSet: updateUnreadCommentIDSet
                            });
                        }
                    }).then(()=>{
                        succeedCommentsPubSubExperience();
                    }).catch((err)=>{
                        failCommentsPubSubExperience(err);
                    });
                    else failCommentsPubSubExperience(new Error('commentReopened: reloader is not defined'));
                    // Remove from commentThreadsRemovedByOtherUsers when reopened
                    if (commentId && reopenParentComment) reopenParentComment({
                        threadKey: commentId,
                        commentType: (0, $8i27m.CommentType).GENERAL,
                        parentCommentId: commentId
                    });
                    break;
                case 'commentUpdated':
                case 'avi:confluence:updated:comment':
                    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                        if (commentId) // fetchCommentById implicitly updates useAllCommentsDataQuery cache
                        (0, $lb2Lp.fetchCommentById)({
                            commentId: commentId,
                            contentId: contentId,
                            fetchPolicy: 'network-only'
                        }).then(()=>{
                            succeedCommentsPubSubExperience();
                        }).catch((err)=>{
                            failCommentsPubSubExperience(err);
                        });
                        else failCommentsPubSubExperience(new Error('commentUpdated: commentId is not defined'));
                    } else if (updateQueryVariables) Promise.all([
                        $ced40be9017d58cb$export$9cc4fc7c59ab4b10({
                            commentId: commentId,
                            contentId: contentId,
                            updateCommentBody: updateCommentBody
                        }),
                        (0, $aM1he.updateComment)(commentId, updateQueryVariables)
                    ]).then(()=>{
                        succeedCommentsPubSubExperience();
                    }).catch((err)=>{
                        failCommentsPubSubExperience(err);
                    });
                    else failCommentsPubSubExperience(new Error('commentUpdated: updateQueryVariables is not defined'));
                    break;
                default:
                    failCommentsPubSubExperience(new Error(`Unhandled comments pubsub event: ${event}`));
                    break;
            }
        } catch (error) {
            failCommentsPubSubExperience(error);
            throw error;
        }
    };
const $ced40be9017d58cb$export$c542af303309df99 = ({ contentId: contentId, contentType: contentType, userId: userId, reloader: reloader, addNewComment: addNewComment, removeComment: removeComment, queryArgs: { isReactionsEnabled: isReactionsEnabled }, addNewCommentThreads: addNewCommentThreads, addReplyToCommentThread: addReplyToCommentThread, updateCommentBody: updateCommentBody, updateRemovedCommentIdsMap: updateRemovedCommentIdsMap, reopenParentComment: reopenParentComment, getCurrentCommentsPanelState: getCurrentCommentsPanelState, addSubscriber: addSubscriber, setContentType: setContentType, setContentId: setContentId, updateUnreadCommentIDSet: updateUnreadCommentIDSet, getViewedCommentsCacheOnly: getViewedCommentsCacheOnly, addCommentInCache: addCommentInCache, deleteCommentInCache: deleteCommentInCache, clearReplyIfRemoved: clearReplyIfRemoved })=>{
    const pubSubResourceType = contentType || 'page';
    const subscriberIds = [];
    // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) {
        if (!addSubscriber || !setContentType || !setContentId) return;
        setContentType(pubSubResourceType);
        setContentId(contentId);
        const subscribers = [
            {
                subscriberId: 'pageCommentsPubSubCommentCreated',
                onSubscriptionData: $ced40be9017d58cb$export$4d067148c1e8c84d({
                    userId: userId,
                    contentId: contentId,
                    reloader: reloader,
                    addNewComment: addNewComment,
                    addNewCommentThreads: addNewCommentThreads,
                    addReplyToCommentThread: addReplyToCommentThread,
                    updateUnreadCommentIDSet: updateUnreadCommentIDSet,
                    addCommentInCache: addCommentInCache
                }),
                delta: 'commentCreated'
            },
            {
                subscriberId: 'pageCommentsPubSubCommentResolved',
                onSubscriptionData: $ced40be9017d58cb$export$4d067148c1e8c84d({
                    userId: userId,
                    contentId: contentId,
                    reloader: reloader,
                    addNewComment: addNewComment,
                    updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
                    updateUnreadCommentIDSet: updateUnreadCommentIDSet,
                    clearReplyIfRemoved: clearReplyIfRemoved
                }),
                delta: 'commentResolved'
            },
            {
                subscriberId: 'pageCommentsPubSubCommentDeleted',
                onSubscriptionData: $ced40be9017d58cb$export$4d067148c1e8c84d({
                    userId: userId,
                    contentId: contentId,
                    reloader: reloader,
                    removeComment: removeComment,
                    updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
                    getCurrentCommentsPanelState: getCurrentCommentsPanelState,
                    updateUnreadCommentIDSet: updateUnreadCommentIDSet,
                    deleteCommentInCache: deleteCommentInCache,
                    clearReplyIfRemoved: clearReplyIfRemoved
                }),
                delta: 'commentDeleted'
            },
            {
                subscriberId: 'pageCommentsPubSubCommentReopened',
                onSubscriptionData: $ced40be9017d58cb$export$4d067148c1e8c84d({
                    userId: userId,
                    contentId: contentId,
                    reloader: reloader,
                    addNewComment: addNewComment,
                    addNewCommentThreads: addNewCommentThreads,
                    reopenParentComment: reopenParentComment,
                    getCurrentCommentsPanelState: getCurrentCommentsPanelState,
                    getViewedCommentsCacheOnly: getViewedCommentsCacheOnly,
                    updateUnreadCommentIDSet: updateUnreadCommentIDSet
                }),
                delta: 'commentReopened'
            },
            {
                subscriberId: 'pageCommentsPubSubCommentUpdated',
                onSubscriptionData: $ced40be9017d58cb$export$4d067148c1e8c84d({
                    userId: userId,
                    contentId: contentId,
                    updateQueryVariables: {
                        contentId: contentId,
                        isReactionsEnabled: isReactionsEnabled
                    },
                    updateCommentBody: updateCommentBody
                }),
                delta: 'commentUpdated'
            }
        ];
        for (const subscriber of subscribers)subscriberIds.push({
            subscriberId: addSubscriber(subscriber),
            delta: subscriber.delta
        });
        return subscriberIds;
    } else (0, $gRrX4.getPubSubClient)().then((client)=>{
        client.joinChannel(pubSubResourceType, contentId).finally(()=>{
            client.subscribe((0, $7S9uM.eventToAvi)('created:comment'), $ced40be9017d58cb$export$4d067148c1e8c84d({
                userId: userId,
                contentId: contentId,
                reloader: reloader,
                addNewComment: addNewComment,
                addNewCommentThreads: addNewCommentThreads,
                addReplyToCommentThread: addReplyToCommentThread,
                updateUnreadCommentIDSet: updateUnreadCommentIDSet,
                addCommentInCache: addCommentInCache
            }));
            client.subscribe((0, $7S9uM.eventToAvi)('resolved:comment'), $ced40be9017d58cb$export$4d067148c1e8c84d({
                userId: userId,
                contentId: contentId,
                reloader: reloader,
                addNewComment: addNewComment,
                updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
                updateUnreadCommentIDSet: updateUnreadCommentIDSet
            }));
            client.subscribe((0, $7S9uM.eventToAvi)('deleted:comment'), $ced40be9017d58cb$export$4d067148c1e8c84d({
                userId: userId,
                contentId: contentId,
                reloader: reloader,
                removeComment: removeComment,
                updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
                getCurrentCommentsPanelState: getCurrentCommentsPanelState,
                updateUnreadCommentIDSet: updateUnreadCommentIDSet,
                deleteCommentInCache: deleteCommentInCache
            }));
            client.subscribe((0, $7S9uM.eventToAvi)('reopen:comment'), $ced40be9017d58cb$export$4d067148c1e8c84d({
                userId: userId,
                contentId: contentId,
                reloader: reloader,
                addNewComment: addNewComment,
                addNewCommentThreads: addNewCommentThreads,
                reopenParentComment: reopenParentComment,
                getCurrentCommentsPanelState: getCurrentCommentsPanelState,
                getViewedCommentsCacheOnly: getViewedCommentsCacheOnly,
                updateUnreadCommentIDSet: updateUnreadCommentIDSet
            }));
            client.subscribe((0, $7S9uM.eventToAvi)('updated:comment'), $ced40be9017d58cb$export$4d067148c1e8c84d({
                userId: userId,
                contentId: contentId,
                updateQueryVariables: {
                    contentId: contentId,
                    isReactionsEnabled: isReactionsEnabled
                },
                updateCommentBody: updateCommentBody
            }));
        }).catch((error)=>{
            throw new Error(`Unable to joinChannel ${JSON.stringify(error)}`);
        });
    });
};
const $ced40be9017d58cb$export$f6e2e9a186163b28 = ({ contentId: contentId, contentType: contentType, userId: userId, reloader: reloader, addNewComment: addNewComment, removeComment: removeComment, queryArgs: { isReactionsEnabled: isReactionsEnabled }, removeSubscriber: removeSubscriber, subscriptions: subscriptions, getViewedCommentsCacheOnly: getViewedCommentsCacheOnly })=>{
    const pubSubResourceType = contentType || 'page';
    const eventsToUnsubscribe = [
        'commentCreated',
        'commentDeleted',
        'commentUpdated'
    ];
    // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) {
        if (!removeSubscriber || !subscriptions?.length) return;
        for (const subscriber of subscriptions)if (eventsToUnsubscribe.includes(subscriber.delta)) removeSubscriber(subscriber);
    } else (0, $gRrX4.getPubSubClient)().then((client)=>{
        client.leaveChannel(pubSubResourceType, contentId);
        client.unsubscribe((0, $7S9uM.eventToAvi)('created:comment'), $ced40be9017d58cb$export$4d067148c1e8c84d({
            userId: userId,
            contentId: contentId,
            reloader: reloader,
            addNewComment: addNewComment,
            getViewedCommentsCacheOnly: getViewedCommentsCacheOnly
        }));
        client.unsubscribe((0, $7S9uM.eventToAvi)('deleted:comment'), $ced40be9017d58cb$export$4d067148c1e8c84d({
            userId: userId,
            contentId: contentId,
            reloader: reloader,
            removeComment: removeComment,
            getViewedCommentsCacheOnly: getViewedCommentsCacheOnly
        }));
        client.unsubscribe((0, $7S9uM.eventToAvi)('updated:comment'), $ced40be9017d58cb$export$4d067148c1e8c84d({
            userId: userId,
            contentId: contentId,
            updateQueryVariables: {
                contentId: contentId,
                isReactionsEnabled: isReactionsEnabled
            },
            getViewedCommentsCacheOnly: getViewedCommentsCacheOnly
        }));
    });
};
module.exports["setUpPageCommentsPubSub"] = $ced40be9017d58cb$export$c542af303309df99;
module.exports["removePageCommentsPubSub"] = $ced40be9017d58cb$export$f6e2e9a186163b28;

});

parcelRegister("kQekh", function(module, exports) {

var $k5aG8 = parcelRequire("k5aG8");


var $f9FCO = parcelRequire("f9FCO");

const $90ffe60e2eae60ca$export$bf87400a8da436f8 = (0, $f9FCO.default);
const $90ffe60e2eae60ca$export$caecd77287327384 = (0, $k5aG8.default);
module.exports["CommentsSectionGetSingleCommentQuery"] = $90ffe60e2eae60ca$export$bf87400a8da436f8;
module.exports["CommentsSectionGetSingleCommentWithoutReactionsQuery"] = $90ffe60e2eae60ca$export$caecd77287327384;

});

parcelRegister("k5aG8", function(module, exports) {
/**
 * @generated SignedSource<<8ed7915c440f335b6a58fb7784fdbb97>>
 * @relayHash d3bcc60b520b9e62b29ac8be494a67be
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7283bb4b16c1cdbaba6a6dd79d25ca7b709cb15a18141ac1fd787bca033d468c
const $2711060718729916$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "commentId",
            "variableName": "commentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "ancestors",
        "plural": true,
        "selections": [
            v2 /*: any*/ 
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "permissionType"
            }
        ],
        "type": "KnownUser"
    }, v9 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v10 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v9 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v11 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v12 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v9 /*: any*/ 
    }, v13 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v14 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v16 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v17 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v18 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v19 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v15 /*: any*/ ,
                    v16 /*: any*/ ,
                    v17 /*: any*/ ,
                    v18 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v20 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v15 /*: any*/ ,
                    v16 /*: any*/ ,
                    v17 /*: any*/ ,
                    v18 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v21 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v22 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v24 = {
        "kind": "ScalarField",
        "name": "number"
    }, v25 = {
        "kind": "ScalarField",
        "name": "when"
    }, v26 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ 
        ],
        "type": "KnownUser"
    }, v27 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CommentsSectionGetSingleCommentQueryWithoutReactionsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                },
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v26 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CommentsSectionGetSingleCommentQueryWithoutReactionsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v27 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v27 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                },
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v27 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v26 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "d3bcc60b520b9e62b29ac8be494a67be",
            "id": "7283bb4b16c1cdbaba6a6dd79d25ca7b709cb15a18141ac1fd787bca033d468c",
            "metadata": {},
            "name": "CommentsSectionGetSingleCommentQueryWithoutReactionsQuery",
            "operationKind": "query",
            "text": "query CommentsSectionGetSingleCommentQueryWithoutReactionsQuery($commentId:ID!){comments(commentId:$commentId){nodes{id,ancestors{id},author{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId,permissionType}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{isDangling,resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}},...on FooterComment{commentResolveProperties{resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{friendlyWhen,number,when,by{__typename,type,displayName,...on KnownUser{accountId}}}}}}"
        }
    };
}();
$2711060718729916$var$node.hash = "2d393682eae4feef3986d5e4ea1bd5a6";
var $2711060718729916$export$2e2bcd8739ae039 = $2711060718729916$var$node;
module.exports["default"] = $2711060718729916$export$2e2bcd8739ae039;

});

parcelRegister("f9FCO", function(module, exports) {
/**
 * @generated SignedSource<<ba3d28415cb064032a9b12514118849b>>
 * @relayHash 1a3bffe088c5850ddf1b9c1ca4f044de
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 99bae9281cfcad757a48d4ce24663228d32566fabd997953e6327a8ca274f81a
const $c1f0ddf438970e3e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "commentId",
            "variableName": "commentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "ancestors",
        "plural": true,
        "selections": [
            v2 /*: any*/ 
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "permissionType"
            }
        ],
        "type": "KnownUser"
    }, v9 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v10 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v9 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v11 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v12 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v9 /*: any*/ 
    }, v13 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v14 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v16 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v17 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v18 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v19 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v15 /*: any*/ ,
                    v16 /*: any*/ ,
                    v17 /*: any*/ ,
                    v18 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v20 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v15 /*: any*/ ,
                    v16 /*: any*/ ,
                    v17 /*: any*/ ,
                    v18 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v21 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v22 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v24 = {
        "kind": "ScalarField",
        "name": "number"
    }, v25 = {
        "kind": "ScalarField",
        "name": "when"
    }, v26 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ 
        ],
        "type": "KnownUser"
    }, v27 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            {
                "kind": "Variable",
                "name": "pageId",
                "variableName": "contentId"
            }
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v2 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v28 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CommentsSectionGetSingleCommentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                },
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v26 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v27 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CommentsSectionGetSingleCommentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v28 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v28 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                },
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v28 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v26 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v27 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "1a3bffe088c5850ddf1b9c1ca4f044de",
            "id": "99bae9281cfcad757a48d4ce24663228d32566fabd997953e6327a8ca274f81a",
            "metadata": {},
            "name": "CommentsSectionGetSingleCommentQuery",
            "operationKind": "query",
            "text": "query CommentsSectionGetSingleCommentQuery($commentId:ID!,$contentId:ID!){comments(commentId:$commentId){nodes{id,ancestors{id},author{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId,permissionType}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{isDangling,resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}},...on FooterComment{commentResolveProperties{resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{friendlyWhen,number,when,by{__typename,type,displayName,...on KnownUser{accountId}}},reactionsSummary(pageId:$contentId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}}}}"
        }
    };
}();
$c1f0ddf438970e3e$var$node.hash = "326ee68c128aba1a564502e019c38ae6";
var $c1f0ddf438970e3e$export$2e2bcd8739ae039 = $c1f0ddf438970e3e$var$node;
module.exports["default"] = $c1f0ddf438970e3e$export$2e2bcd8739ae039;

});

parcelRegister("jLcXM", function(module, exports) {

var $233nj = parcelRequire("233nj");

const $f35c50316f68c508$export$34ea693bdbe9d3f6 = (0, $233nj.default);
module.exports["ActivePageCommentQuery"] = $f35c50316f68c508$export$34ea693bdbe9d3f6;

});

parcelRegister("233nj", function(module, exports) {
/**
 * @generated SignedSource<<8d67f7ad40d94c56816dcc35e2d1abb9>>
 * @relayHash 4b2b231d2dc45d90f0e6c67f64d74442
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 59117d0e39c953fac3a300093542641681064ffbd898fae1d4fd06ea427e52d0
const $6a66bb9e87369108$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "commentId",
            "variableName": "commentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "ancestors",
        "plural": true,
        "selections": [
            v2 /*: any*/ 
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "permissionType"
            }
        ],
        "type": "KnownUser"
    }, v9 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v10 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v9 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v11 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v12 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v9 /*: any*/ 
    }, v13 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v14 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v16 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v17 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v18 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v19 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v15 /*: any*/ ,
                    v16 /*: any*/ ,
                    v17 /*: any*/ ,
                    v18 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v20 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v15 /*: any*/ ,
                    v16 /*: any*/ ,
                    v17 /*: any*/ ,
                    v18 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v21 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v22 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v24 = {
        "kind": "ScalarField",
        "name": "number"
    }, v25 = {
        "kind": "ScalarField",
        "name": "when"
    }, v26 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ 
        ],
        "type": "KnownUser"
    }, v27 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            {
                "kind": "Variable",
                "name": "pageId",
                "variableName": "contentId"
            }
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v2 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v28 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ActivePageCommentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                },
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v26 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v27 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v12 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v21 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ActivePageCommentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v28 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v28 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                },
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v28 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v26 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v27 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                v28 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v12 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v21 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "4b2b231d2dc45d90f0e6c67f64d74442",
            "id": "59117d0e39c953fac3a300093542641681064ffbd898fae1d4fd06ea427e52d0",
            "metadata": {},
            "name": "ActivePageCommentQuery",
            "operationKind": "query",
            "text": "query ActivePageCommentQuery($commentId:ID!,$contentId:ID!){comments(commentId:$commentId){nodes{id,ancestors{id},author{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId,permissionType}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{isDangling,resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}},...on FooterComment{commentResolveProperties{resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{friendlyWhen,number,when,by{__typename,type,displayName,...on KnownUser{accountId}}},reactionsSummary(pageId:$contentId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}},replies{id,author{__typename,type,...on KnownUser{accountId,permissionType}},createdAt{value},createdAtNonLocalized,parentId}}}}"
        }
    };
}();
$6a66bb9e87369108$var$node.hash = "74318b0c1a4a8927e074ad4bb12d4099";
var $6a66bb9e87369108$export$2e2bcd8739ae039 = $6a66bb9e87369108$var$node;
module.exports["default"] = $6a66bb9e87369108$export$2e2bcd8739ae039;

});

parcelRegister("aM1he", function(module, exports) {

var $kQekh = parcelRequire("kQekh");


var $c0rhi = parcelRequire("c0rhi");

const $406672c94379d4ab$export$5a1cd239009d83a6 = async (commentId, { contentId: contentId, isReactionsEnabled: isReactionsEnabled })=>{
    const query = isReactionsEnabled ? (0, $kQekh.CommentsSectionGetSingleCommentQuery) : (0, $kQekh.CommentsSectionGetSingleCommentWithoutReactionsQuery);
    const variables = isReactionsEnabled ? {
        commentId: commentId,
        contentId: contentId
    } : {
        commentId: commentId
    };
    // Query the single comment to update the cache
    (0, $c0rhi.queryInterop)({
        query: query,
        variables: variables,
        __callerPackage__: "comments-pubsub"
    });
};
const $406672c94379d4ab$export$af4b8274c1b86043 = (reloader, addNewComment, commentData, currentUserId)=>reloader().then(()=>{
        setTimeout(()=>{
            // HACK: Give the comments section time to render the new comment
            commentData.forEach((data)=>{
                addNewComment({
                    newCommentId: data.commentId,
                    currentUserMadeComment: data.accountId === currentUserId
                });
            });
        }, 3000);
    }).catch((err)=>{
        throw err;
    });
module.exports["updateComment"] = $406672c94379d4ab$export$5a1cd239009d83a6;
module.exports["reloadAndAddPageComments"] = $406672c94379d4ab$export$af4b8274c1b86043;

});

parcelRegister("2xS8W", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $w6R6I = parcelRequire("w6R6I");


var $1d2ww = parcelRequire("1d2ww");


var $3mVfX = parcelRequire("3mVfX");


var $aHcFH = parcelRequire("aHcFH");


var $6mKj3 = parcelRequire("6mKj3");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $fNzRA = parcelRequire("fNzRA");


var $ep3mz = parcelRequire("ep3mz");


var $jAfH5 = parcelRequire("jAfH5");


var $aOKRX = parcelRequire("aOKRX");


var $niTts = parcelRequire("niTts");


var $l1B53 = parcelRequire("l1B53");


var $dL5YQ = parcelRequire("dL5YQ");

const $e3138de675756a06$var$styles = {
    stickyDraftViewPageWrapper: "_kqsw1if8 _1pbykb7n",
    stickyDraftLivePageWrapper: "_kqsw1n9t _1pbybfng",
    hiddenStyles: "_1e0cglyw",
    visibleStyles: "_1e0c1txw",
    commonStyle: "_4cvr1h6o _1bah1h6o _94n5ze3t _bfhkvuon",
    childWrapperStyle: "_1yt4pxbi _19pkidpf _2hwx1wug _otyridpf _18u01wug _1h6d1l7x _uwhke4h9 _15a5nqa1",
    zIndexStyle: "_1pby1kze _1ltvze3t _1bsb1osq"
};
const $e3138de675756a06$export$d2696a038fec0750 = (t0)=>{
    const $ = (0, $bDgLe.c)(54);
    const { pageWidthType: pageWidthType } = t0;
    const { expanded: expanded, isObjectCommentWrapperVisible: isObjectCommentWrapperVisible, footerEditorEntry: footerEditorEntry } = (0, $fNzRA.useObjectCommentContext)();
    const { expandCommentContainer: expandCommentContainer, setWrapperWidth: setWrapperWidth, setIsObjectCommentWrapperVisible: setIsObjectCommentWrapperVisible, setFooterEditorEntry: setFooterEditorEntry } = (0, $fNzRA.useObjectCommentDispatchContext)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [objectCommentWrapperDimensions, setObjectCommentWrapperDimensions] = (0, $cozmU.useState)(null);
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const isViewPage = pageMode === (0, $cD1qu.PageMode).VIEW;
    const { width: pageContentWidth, left: pageContentLeft, right: pageContentRight } = (0, $aOKRX.usePageContentDimensions)();
    const { hasRecs: hasRecs } = (0, $jAfH5.usePageRecommendationData)();
    const { addFooterCommentAdf: addFooterCommentAdf } = (0, $3mVfX.useCommentsPanelState)();
    let t1;
    let t2;
    if ($[0] !== expandCommentContainer || $[1] !== expanded || $[2] !== isObjectCommentWrapperVisible || $[3] !== setFooterEditorEntry) {
        t1 = ()=>{
            if (isObjectCommentWrapperVisible && expanded) {
                expandCommentContainer();
                setFooterEditorEntry((0, $3mVfX.AddFooterCommentMode).FOOTER);
            }
        };
        t2 = [
            isObjectCommentWrapperVisible,
            expandCommentContainer,
            expanded,
            setFooterEditorEntry
        ];
        $[0] = expandCommentContainer;
        $[1] = expanded;
        $[2] = isObjectCommentWrapperVisible;
        $[3] = setFooterEditorEntry;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[6] !== isViewPage || $[7] !== setIsObjectCommentWrapperVisible || $[8] !== setWrapperWidth) {
        t3 = ()=>{
            let intersectionObserver = null;
            let resizeObserver = null;
            const calculateObjectCommentWrapperWidth = ()=>{
                const objectCommentWrapper = document.querySelector("[data-testid=\"object-comment-wrapper\"]");
                if (objectCommentWrapper) {
                    const rect = objectCommentWrapper.getBoundingClientRect();
                    setObjectCommentWrapperDimensions({
                        width: rect.width
                    });
                    setWrapperWidth(rect.width);
                }
            };
            const setupObservers = ()=>{
                const commentWrapper = document.querySelector("[data-testid=\"object-comment-wrapper\"]");
                if (!commentWrapper) {
                    setIsObjectCommentWrapperVisible(false);
                    return;
                }
                if (!intersectionObserver) {
                    intersectionObserver = new IntersectionObserver((t4)=>{
                        const [entry] = t4;
                        setIsObjectCommentWrapperVisible(entry.isIntersecting);
                    }, {
                        rootMargin: "0px"
                    });
                    intersectionObserver.observe(commentWrapper);
                }
                if (!resizeObserver) {
                    resizeObserver = new ResizeObserver(()=>{
                        calculateObjectCommentWrapperWidth();
                    });
                    resizeObserver.observe(commentWrapper);
                }
                calculateObjectCommentWrapperWidth();
            };
            setupObservers();
            const mutationObserver = new MutationObserver(()=>{
                const commentWrapper_0 = document.querySelector("[data-testid=\"object-comment-wrapper\"]");
                if (commentWrapper_0 && (!intersectionObserver || !isViewPage && !resizeObserver)) setupObservers();
            });
            mutationObserver.observe(document.body, {
                childList: true,
                subtree: true
            });
            return ()=>{
                if (intersectionObserver) intersectionObserver.disconnect();
                if (resizeObserver) resizeObserver.disconnect();
                mutationObserver.disconnect();
            };
        };
        $[6] = isViewPage;
        $[7] = setIsObjectCommentWrapperVisible;
        $[8] = setWrapperWidth;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== contentId || $[11] !== isViewPage || $[12] !== setIsObjectCommentWrapperVisible || $[13] !== setWrapperWidth) {
        t4 = [
            isViewPage,
            setWrapperWidth,
            setIsObjectCommentWrapperVisible,
            contentId
        ];
        $[10] = contentId;
        $[11] = isViewPage;
        $[12] = setIsObjectCommentWrapperVisible;
        $[13] = setWrapperWidth;
        $[14] = t4;
    } else t4 = $[14];
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[15] !== pageContentLeft || $[16] !== pageContentRight || $[17] !== pageContentWidth) {
        t5 = {
            width: pageContentWidth,
            left: pageContentLeft,
            right: pageContentRight
        };
        $[15] = pageContentLeft;
        $[16] = pageContentRight;
        $[17] = pageContentWidth;
        $[18] = t5;
    } else t5 = $[18];
    const pageContentDimensions = t5;
    let t6;
    if ($[19] !== pageWidthType) {
        t6 = ()=>{
            if (pageWidthType === undefined) return "100%";
            return JSON.parse(pageWidthType) === (0, $1d2ww.ContentAppearanceType).DEFAULT ? "1000px" : "unset";
        };
        $[19] = pageWidthType;
        $[20] = t6;
    } else t6 = $[20];
    const getMaxWidth = t6;
    let t7;
    if ($[21] !== getMaxWidth || $[22] !== hasRecs || $[23] !== isViewPage || $[24] !== objectCommentWrapperDimensions || $[25] !== pageMode || $[26] !== pageWidthType) {
        t7 = ()=>{
            if (isViewPage && (0, $6mKj3.expValEquals)("confluence_unify_footer_comments_space_width", "isEnabled", true)) {
                const computedWidths = (0, $aHcFH.getWidthAndMaxWidth)({
                    pageMode: pageMode,
                    pageWidthType: pageWidthType,
                    hasEndOfPageRecommendations: hasRecs ?? false
                });
                return {
                    width: computedWidths.width,
                    maxWidth: computedWidths.maxWidth
                };
            }
            return {
                maxWidth: isViewPage ? getMaxWidth() : "100%",
                width: !isViewPage && objectCommentWrapperDimensions ? `${objectCommentWrapperDimensions.width}px` : "100%"
            };
        };
        $[21] = getMaxWidth;
        $[22] = hasRecs;
        $[23] = isViewPage;
        $[24] = objectCommentWrapperDimensions;
        $[25] = pageMode;
        $[26] = pageWidthType;
        $[27] = t7;
    } else t7 = $[27];
    const getStyle = t7;
    const showStickyDraft = !isObjectCommentWrapperVisible && (addFooterCommentAdf || expanded) && footerEditorEntry !== (0, $3mVfX.AddFooterCommentMode).STICKY_DRAFT;
    let t8;
    if ($[28] !== expandCommentContainer || $[29] !== setFooterEditorEntry) {
        t8 = ()=>{
            expandCommentContainer();
            setFooterEditorEntry((0, $3mVfX.AddFooterCommentMode).STICKY_DRAFT);
        };
        $[28] = expandCommentContainer;
        $[29] = setFooterEditorEntry;
        $[30] = t8;
    } else t8 = $[30];
    const expandEditorHandler = t8;
    if (!showStickyDraft) return;
    const t9 = isViewPage ? $e3138de675756a06$var$styles.stickyDraftViewPageWrapper : $e3138de675756a06$var$styles.stickyDraftLivePageWrapper;
    const t10 = showStickyDraft ? $e3138de675756a06$var$styles.visibleStyles : $e3138de675756a06$var$styles.hiddenStyles;
    const t11 = !isViewPage && $e3138de675756a06$var$styles.zIndexStyle;
    let t12;
    if ($[31] !== t10 || $[32] !== t11 || $[33] !== t9) {
        t12 = (0, $w6R6I.cx)(t9, t10, $e3138de675756a06$var$styles.commonStyle, t11);
        $[31] = t10;
        $[32] = t11;
        $[33] = t9;
        $[34] = t12;
    } else t12 = $[34];
    let t13;
    if ($[35] !== pageContentDimensions || $[36] !== pageMode) {
        t13 = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $niTts.hideWhiteSpace)({
            shouldRenderFixedStyle: true,
            pageContentDimensions: pageContentDimensions
        }) : undefined;
        $[35] = pageContentDimensions;
        $[36] = pageMode;
        $[37] = t13;
    } else t13 = $[37];
    let t14;
    if ($[38] !== getStyle) {
        t14 = getStyle();
        $[38] = getStyle;
        $[39] = t14;
    } else t14 = $[39];
    const t15 = !showStickyDraft ? $e3138de675756a06$var$styles.hiddenStyles : $e3138de675756a06$var$styles.visibleStyles;
    let t16;
    if ($[40] !== t15) {
        t16 = (0, $w6R6I.cx)(t15);
        $[40] = t15;
        $[41] = t16;
    } else t16 = $[41];
    let t17;
    if ($[42] !== expandEditorHandler) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l1B53.DraftCommentBox), {
            expandPageCommentEditorHandler: expandEditorHandler
        });
        $[42] = expandEditorHandler;
        $[43] = t17;
    } else t17 = $[43];
    let t18;
    if ($[44] !== t16 || $[45] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dL5YQ.ObjectAddCommentProfileWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t16
        }, t17)));
        $[44] = t16;
        $[45] = t17;
        $[46] = t18;
    } else t18 = $[46];
    let t19;
    if ($[47] !== t14 || $[48] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $e3138de675756a06$var$styles.childWrapperStyle,
            style: t14
        }, t18);
        $[47] = t14;
        $[48] = t18;
        $[49] = t19;
    } else t19 = $[49];
    let t20;
    if ($[50] !== t12 || $[51] !== t13 || $[52] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t12,
            testId: "sticky-draft-comment-box",
            id: "addCommentButton-draft",
            style: t13
        }, t19);
        $[50] = t12;
        $[51] = t13;
        $[52] = t19;
        $[53] = t20;
    } else t20 = $[53];
    return t20;
};
module.exports["StickyDraftCommentContainer"] = $e3138de675756a06$export$d2696a038fec0750;

});

parcelRegister("jAfH5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $jtuBN = parcelRequire("jtuBN");


var $ep3mz = parcelRequire("ep3mz");


var $2HQyh = parcelRequire("2HQyh");


var $8dbvt = parcelRequire("8dbvt");

const $7e53ce3ad8fd4fef$export$1d93f080b8c40251 = (skip = false)=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const baseOptions = {
        variables: {
            type: 'page',
            id: contentId ?? '',
            exp: 'end_of_page_v5',
            key: spaceKey ?? '',
            keyString: spaceKey ?? ''
        },
        context: {
            single: true
        },
        errorPolicy: 'all',
        skip: skip
    };
    const { error: error, loading: loading, data: data } = (0, $6mKj3.expValEquals)('confluence_frontend_stop_watching_queries', 'isEnabled', true) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $2HQyh.default), {
        ...baseOptions,
        __callerPackage__: "page-recommendations"
    }) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)((0, $2HQyh.default), {
        ...baseOptions,
        __callerPackage__: "page-recommendations"
    });
    const pageCardData = (0, $cozmU.useMemo)(()=>(0, $8dbvt.transformAndOrderRecs)(data?.getRecommendedPages?.recommendedPages), [
        data
    ]);
    if (error || skip) return {
        loading: false,
        error: error,
        data: undefined,
        hasRecs: false
    };
    return {
        loading: loading,
        error: error,
        data: pageCardData,
        hasRecs: pageCardData && pageCardData.length > 2
    };
};
module.exports["usePageRecommendationData"] = $7e53ce3ad8fd4fef$export$1d93f080b8c40251;

});

parcelRegister("aOKRX", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $b6b1455842ddb08b$export$d0606705f36ae70a = ()=>{
    const $ = (0, $bDgLe.c)(6);
    const [pageContentWidth, setPageContentWidth] = (0, $cozmU.useState)(0);
    const [pageContentLeft, setPageContentLeft] = (0, $cozmU.useState)(0);
    const [pageContentRight, setPageContentRight] = (0, $cozmU.useState)(0);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            let resizeObserver = null;
            let mutationObserver = null;
            let pageContentOnly = null;
            const updateDimensions = ()=>{
                if (!pageContentOnly) return;
                const rect = pageContentOnly.getBoundingClientRect();
                setPageContentWidth(rect.width);
                setPageContentLeft(rect.left);
                setPageContentRight(rect.right);
            };
            const handleWindowResize = ()=>{
                updateDimensions();
            };
            window.addEventListener("resize", handleWindowResize);
            const setupObservers = (element)=>{
                pageContentOnly = element;
                if (resizeObserver) resizeObserver.disconnect();
                resizeObserver = new ResizeObserver(()=>{
                    updateDimensions();
                });
                resizeObserver.observe(element);
                updateDimensions();
            };
            const existingElement = document.querySelector("[data-testid='page-content-only']");
            if (existingElement) setupObservers(existingElement);
            mutationObserver = new MutationObserver(()=>{
                const newPageContentOnly = document.querySelector("[data-testid='page-content-only']");
                if (newPageContentOnly && newPageContentOnly !== pageContentOnly) setupObservers(newPageContentOnly);
            });
            mutationObserver.observe(document.body, {
                childList: true,
                subtree: true
            });
            return ()=>{
                if (resizeObserver) resizeObserver.disconnect();
                window.removeEventListener("resize", handleWindowResize);
                if (mutationObserver) mutationObserver.disconnect();
            };
        };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[2] !== pageContentLeft || $[3] !== pageContentRight || $[4] !== pageContentWidth) {
        t2 = {
            width: pageContentWidth,
            left: pageContentLeft,
            right: pageContentRight
        };
        $[2] = pageContentLeft;
        $[3] = pageContentRight;
        $[4] = pageContentWidth;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
};
module.exports["usePageContentDimensions"] = $b6b1455842ddb08b$export$d0606705f36ae70a;

});

parcelRegister("niTts", function(module, exports) {
const $829c98791d74b4c3$export$a9fce9e535ae2163 = ({ shouldRenderFixedStyle: shouldRenderFixedStyle, pageContentDimensions: pageContentDimensions, fallbackWidth: fallbackWidth = '100%' })=>{
    if (!shouldRenderFixedStyle) return {
        width: fallbackWidth
    };
    const { width: pageContentWidth, left: pageContentLeft, right: pageContentRight } = pageContentDimensions;
    // Handle case where dimensions might be undefined or width might be a string
    const width = typeof pageContentWidth === 'number' ? pageContentWidth : 0;
    const left = pageContentLeft ?? 0;
    const right = pageContentRight ?? 0;
    return {
        left: left > 0 ? `${left}px` : '0px',
        right: right > 0 ? `${window.innerWidth - right}px` : '0px',
        width: width > 0 ? `${width}px` : '100%'
    };
};
module.exports["hideWhiteSpace"] = $829c98791d74b4c3$export$a9fce9e535ae2163;

});

parcelRegister("l1B53", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $hBYtq = parcelRequire("hBYtq");

const $656c656df397599d$var$styles = {
    draftComment: "_2rko12b0 _1yt4u2gc _189ee4h9 _1dqonqa1 _1h6d1l7x _1bsb1osq _4t3i14no _1e0c1txw _4cvr1h6o _1bah1yb4 _syaz1rpy _bfhk1j9a"
};
const $656c656df397599d$var$i18n = (0, $kSwu1.defineMessages)({
    unsavedDraftComment: {
        id: "object-comments.draft-comment-box.text",
        defaultMessage: "Comment in progress - select to continue"
    }
});
const $656c656df397599d$export$82fe65228be9eec = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { testId: t1, expandPageCommentEditorHandler: expandPageCommentEditorHandler } = t0;
    const testId = t1 === undefined ? "draft-comment-box" : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== formatMessage) {
        t2 = formatMessage($656c656df397599d$var$i18n.unsavedDraftComment);
        $[0] = formatMessage;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== expandPageCommentEditorHandler || $[3] !== t2 || $[4] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: $656c656df397599d$var$styles.draftComment,
            testId: testId,
            onClick: expandPageCommentEditorHandler
        }, t2);
        $[2] = expandPageCommentEditorHandler;
        $[3] = t2;
        $[4] = testId;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
};
module.exports["DraftCommentBox"] = $656c656df397599d$export$82fe65228be9eec;

});

parcelRegister("dL5YQ", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $8lS8J = parcelRequire("8lS8J");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $jMyy4 = parcelRequire("jMyy4");


var $9wGTI = parcelRequire("9wGTI");


var $fs6LW = parcelRequire("fs6LW");


var $bQm3c = parcelRequire("bQm3c");


var $e4o8D = parcelRequire("e4o8D");

const $f361dd7d6e4d9bdd$var$ObjectAddCommentProfileWrapperUserQuery = (0, $8lS8J.default);
const $f361dd7d6e4d9bdd$var$styles = {
    addCommentWrapperStyles: "_1bsb1osq",
    addCommentWrapperWithBannerStyles: "_1e0c11p5 _yv0e1ul4 _gy1ppxbi _1bsb1osq",
    addCommentOpenContainerStyles: "_zulppxbi _1e0c1txw _2lx2vrvc _1bsb1osq _4cvr1y6m",
    addCommentOpenContainerWithBannerStyles: "_1e0c1bgi",
    addCommentEditorStyles: "_yyhycs5v _1ii7cs5v _1bsb1osq _1ul9idpf",
    bannerStyles: "_yyhycs5v _1ii7kb7n _1ul9idpf",
    avatarStyles: "_yyhykb7n _1ii7cs5v _1bsbzwfg _4t3izwfg _1o9zidpf"
};
const $f361dd7d6e4d9bdd$var$avatarFloatStyle = {
    float: 'left'
};
const $f361dd7d6e4d9bdd$export$5a360c1cb6170ba8 = (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { children: children, banner: banner } = t0;
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const t1 = userId || "";
    let t2;
    if ($[0] !== t1) {
        t2 = {
            id: t1
        };
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const t3 = !userId;
    let t4;
    if ($[2] !== t2 || $[3] !== t3) {
        t4 = {
            variables: t2,
            fetchPolicy: (0, $9wGTI.fg)("confluence-comments-fix-avatar-flash") ? "cache-first" : "cache-and-network",
            skip: t3
        };
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
    } else t4 = $[4];
    const { data: userData, loading: loading } = (0, $jMyy4.useQueryInterop)($f361dd7d6e4d9bdd$var$ObjectAddCommentProfileWrapperUserQuery, {
        ...t4,
        __callerPackage__: "object-comments"
    });
    const t5 = userData?.user?.photos?.[0]?.value || "";
    const t6 = userData?.user?.displayName || "";
    let t7;
    if ($[5] !== t5 || $[6] !== t6 || $[7] !== userId) {
        t7 = {
            avatarUrl: t5,
            accountId: userId,
            displayName: t6
        };
        $[5] = t5;
        $[6] = t6;
        $[7] = userId;
        $[8] = t7;
    } else t7 = $[8];
    const userInfo = t7;
    const t8 = banner ? $f361dd7d6e4d9bdd$var$styles.addCommentWrapperWithBannerStyles : $f361dd7d6e4d9bdd$var$styles.addCommentWrapperStyles;
    let t9;
    if ($[9] !== banner) {
        t9 = banner ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f361dd7d6e4d9bdd$var$styles.bannerStyles
        }, banner) : null;
        $[9] = banner;
        $[10] = t9;
    } else t9 = $[10];
    const t10 = banner ? $f361dd7d6e4d9bdd$var$styles.addCommentOpenContainerWithBannerStyles : $f361dd7d6e4d9bdd$var$styles.addCommentOpenContainerStyles;
    let t11;
    if ($[11] !== loading || $[12] !== renderServerPlaceholder || $[13] !== userInfo) {
        t11 = loading || renderServerPlaceholder ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fs6LW.ProfileAvatar), {
            canViewProfile: true,
            src: userInfo.avatarUrl,
            userId: userInfo.accountId,
            isAnonymous: !userInfo.accountId,
            name: userInfo.displayName,
            testId: "profile-avatar-comment"
        });
        $[11] = loading;
        $[12] = renderServerPlaceholder;
        $[13] = userInfo;
        $[14] = t11;
    } else t11 = $[14];
    let t12;
    if ($[15] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f361dd7d6e4d9bdd$var$styles.avatarStyles,
            style: $f361dd7d6e4d9bdd$var$avatarFloatStyle
        }, t11);
        $[15] = t11;
        $[16] = t12;
    } else t12 = $[16];
    let t13;
    if ($[17] !== children) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f361dd7d6e4d9bdd$var$styles.addCommentEditorStyles
        }, children);
        $[17] = children;
        $[18] = t13;
    } else t13 = $[18];
    let t14;
    if ($[19] !== t10 || $[20] !== t12 || $[21] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t10
        }, t12, t13);
        $[19] = t10;
        $[20] = t12;
        $[21] = t13;
        $[22] = t14;
    } else t14 = $[22];
    let t15;
    if ($[23] !== t14 || $[24] !== t8 || $[25] !== t9) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t8
        }, t9, t14);
        $[23] = t14;
        $[24] = t8;
        $[25] = t9;
        $[26] = t15;
    } else t15 = $[26];
    return t15;
};
module.exports["ObjectAddCommentProfileWrapper"] = $f361dd7d6e4d9bdd$export$5a360c1cb6170ba8;

});

parcelRegister("8lS8J", function(module, exports) {
/**
 * @generated SignedSource<<41cbeaa06d5991b406f8cd5c92a2f482>>
 * @relayHash 0725da37403499b17b096784b15edae6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a6bddc3903f6a6922c0ab03a3ba2a65c67ef085bec5807493eace122485b54d1
const $a4f88c0b86e6c5fb$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ObjectAddCommentProfileWrapperUserQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ObjectAddCommentProfileWrapperUserQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "0725da37403499b17b096784b15edae6",
            "id": "a6bddc3903f6a6922c0ab03a3ba2a65c67ef085bec5807493eace122485b54d1",
            "metadata": {},
            "name": "ObjectAddCommentProfileWrapperUserQuery",
            "operationKind": "query",
            "text": "query ObjectAddCommentProfileWrapperUserQuery($id:ID!){user:confluence_atlassianUser(id:$id){id,displayName,photos{value}}}"
        }
    };
}();
$a4f88c0b86e6c5fb$var$node.hash = "d4c2e7d15525539be1b21ee5306d9088";
var $a4f88c0b86e6c5fb$export$2e2bcd8739ae039 = $a4f88c0b86e6c5fb$var$node;
module.exports["default"] = $a4f88c0b86e6c5fb$export$2e2bcd8739ae039;

});

parcelRegister("70pcM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3mVfX = parcelRequire("3mVfX");


var $jmjWc = parcelRequire("jmjWc");


var $8zMP3 = parcelRequire("8zMP3");


const $21986f05fdcd4f3c$var$ObjectCommentContainerLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "zDMTR",
    name: "ObjectCommentContainerLoader",
    loader: async ()=>(await (parcelRequire("j8NUu"))).ObjectCommentContainer
});
const $21986f05fdcd4f3c$export$5a58d81bd405c4ec = ({ pageWidthType: pageWidthType, showLabels: showLabels, hasReactions: hasReactions, editorIsUserOffline: editorIsUserOffline, hasCommentSessions: hasCommentSessions })=>{
    const { setShowGeneralComments: setShowGeneralComments } = (0, $3mVfX.useCommentsPanelActions)();
    (0, $cozmU.useEffect)(()=>{
        setShowGeneralComments(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- we only want to set the comment type once on the comment mount
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
        dataFetcherName: "object-comments"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($21986f05fdcd4f3c$var$ObjectCommentContainerLoader, {
        pageWidthType: pageWidthType,
        showLabels: showLabels,
        hasReactions: hasReactions,
        editorIsUserOffline: editorIsUserOffline,
        hasCommentSessions: hasCommentSessions
    }));
};
module.exports["ObjectCommentWrapper"] = $21986f05fdcd4f3c$export$5a58d81bd405c4ec;

});

parcelRegister("j8NUu", function(module, exports) {

let $def57ac780447554$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $def57ac780447554$var$load("5Y1Vv"),
    $def57ac780447554$var$load("8DmEN"),
    $def57ac780447554$var$load("6wr18"),
    $def57ac780447554$var$load("dlm6q"),
    $def57ac780447554$var$load("lsOq1"),
    $def57ac780447554$var$load("lK9vp"),
    $def57ac780447554$var$load("agdLZ"),
    $def57ac780447554$var$load("kxG0W"),
    $def57ac780447554$var$load("byAMe"),
    $def57ac780447554$var$load("l1HBI"),
    $def57ac780447554$var$load("gYeBT"),
    $def57ac780447554$var$load("7k0CW"),
    $def57ac780447554$var$load("3zT1X"),
    $def57ac780447554$var$load("4W6oq"),
    $def57ac780447554$var$load("jqoep"),
    $def57ac780447554$var$load("7EorR"),
    $def57ac780447554$var$load("ffEVr"),
    $def57ac780447554$var$load("c6tdq"),
    $def57ac780447554$var$load("8CGdM"),
    $def57ac780447554$var$load("gzrfp"),
    $def57ac780447554$var$load("79Tk4"),
    $def57ac780447554$var$load("awFK7"),
    $def57ac780447554$var$load("5B6cE"),
    $def57ac780447554$var$load("01KnF")
]).then(()=>parcelRequire('5CNGn'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("hdxAi", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $2d2e882c9a90b3be$var$getInitialState = ()=>({
        deletedMentions: [],
        addedMentions: [],
        deletedTasks: [],
        addedTasks: [],
        unrestrictedMentions: [],
        //Added mentions which have access to the current page
        parentSpaceRestrictedMentions: [],
        //Added mentions which dont have access to the current page due to parent or space restrictions
        pageRestrictedMentions: [],
        //Added mentions which dont have access to the current page due to page restrictions
        unrestrictedTasks: [],
        //Added task mentions which have access to the current page
        parentSpaceRestrictedTasks: [],
        //Added task mentions which dont have access to the current page due to parent or space restrictions
        pageRestrictedTasks: [],
        //Added task mentions which dont have access to the current page due to page restrictions
        editorApi: undefined,
        mentionsAdded: {
            currentUser: [],
            //Mentions of current user added by the current user
            otherUsers: [] //Mentions of other users added by the current user
        },
        tasksAdded: {
            currentUser: [],
            //Task mentions of current user added by the current user
            otherUsers: [] //Task mentions of other users added by the current user
        }
    });
const $2d2e882c9a90b3be$var$actions = {
    setDeletedMentions: (mentions)=>({ setState: setState })=>{
            setState({
                deletedMentions: mentions
            });
        },
    setAddedMentions: (mentions)=>({ setState: setState })=>{
            setState({
                addedMentions: mentions
            });
        },
    setUnrestrictedMentions: (mentions)=>({ setState: setState })=>{
            setState({
                unrestrictedMentions: mentions
            });
        },
    addUnrestrictedMentions: (addedUnrestrictedMentions)=>({ setState: setState, getState: getState })=>{
            const { unrestrictedMentions: unrestrictedMentions } = getState();
            const updatedUnrestrictedMentions = [
                ...unrestrictedMentions,
                ...addedUnrestrictedMentions
            ];
            setState({
                unrestrictedMentions: updatedUnrestrictedMentions
            });
        },
    removeUnrestrictedMentions: (removedUnrestrictedMention)=>({ setState: setState, getState: getState })=>{
            const removedLocalIds = new Set(removedUnrestrictedMention.map((mention)=>mention.localId));
            const { unrestrictedMentions: unrestrictedMentions } = getState();
            const updatedUnrestrictedMentions = unrestrictedMentions.filter((mention)=>!removedLocalIds.has(mention.localId));
            setState({
                unrestrictedMentions: updatedUnrestrictedMentions
            });
        },
    setParentSpaceRestrictedMentions: (mentions)=>({ setState: setState })=>{
            setState({
                parentSpaceRestrictedMentions: mentions
            });
        },
    addParentSpaceRestrictedMentions: (addedParentSpaceRestrictedMentions)=>({ setState: setState, getState: getState })=>{
            const { parentSpaceRestrictedMentions: parentSpaceRestrictedMentions } = getState();
            const updatedParentSpaceRestrictedMentions = [
                ...parentSpaceRestrictedMentions,
                ...addedParentSpaceRestrictedMentions
            ];
            setState({
                parentSpaceRestrictedMentions: updatedParentSpaceRestrictedMentions
            });
        },
    removeParentSpaceRestrictedMentions: (removedParentSpaceRestrictedMentions)=>({ setState: setState, getState: getState })=>{
            const removedLocalIds = new Set(removedParentSpaceRestrictedMentions.map((mention)=>mention.localId));
            const { parentSpaceRestrictedMentions: parentSpaceRestrictedMentions } = getState();
            const updatedParentSpaceRestrictedMentions = parentSpaceRestrictedMentions.filter((mention)=>!removedLocalIds.has(mention.localId));
            setState({
                parentSpaceRestrictedMentions: updatedParentSpaceRestrictedMentions
            });
        },
    setPageRestrictedMentions: (mentions)=>({ setState: setState })=>{
            setState({
                pageRestrictedMentions: mentions
            });
        },
    addPageRestrictedMentions: (addedPageRestrictedMentions)=>({ setState: setState, getState: getState })=>{
            const { pageRestrictedMentions: pageRestrictedMentions } = getState();
            const updatedPageRestrictedMention = [
                ...pageRestrictedMentions,
                ...addedPageRestrictedMentions
            ];
            setState({
                pageRestrictedMentions: updatedPageRestrictedMention
            });
        },
    removePageRestrictedMentions: (removedPageRestrictedMentions)=>({ setState: setState, getState: getState })=>{
            const removedLocalIds = new Set(removedPageRestrictedMentions.map((mention)=>mention.localId));
            const { pageRestrictedMentions: pageRestrictedMentions } = getState();
            const updatedPageRestrictedMention = pageRestrictedMentions.filter((mention)=>!removedLocalIds.has(mention.localId));
            setState({
                pageRestrictedMentions: updatedPageRestrictedMention
            });
        },
    setDeletedTasks: (tasks)=>({ setState: setState })=>{
            setState({
                deletedTasks: tasks
            });
        },
    setAddedTasks: (tasks)=>({ setState: setState })=>{
            setState({
                addedTasks: tasks
            });
        },
    setPageRestrictedTasks: (tasks)=>({ setState: setState })=>{
            setState({
                pageRestrictedTasks: tasks
            });
        },
    addPageRestrictedTasks: (addedPageRestrictedTasks)=>({ setState: setState, getState: getState })=>{
            const { pageRestrictedTasks: pageRestrictedTasks } = getState();
            const updatedPageRestrictedTasks = [
                ...pageRestrictedTasks,
                ...addedPageRestrictedTasks
            ];
            setState({
                pageRestrictedTasks: updatedPageRestrictedTasks
            });
        },
    removePageRestrictedTasks: (removedPageRestrictedTasks)=>({ setState: setState, getState: getState })=>{
            const removedLocalIds = new Set(removedPageRestrictedTasks.map((tasks)=>tasks.localId));
            const { pageRestrictedTasks: pageRestrictedTasks } = getState();
            const updatedPageRestrictedTasks = pageRestrictedTasks.filter((tasks)=>!removedLocalIds.has(tasks.localId));
            setState({
                pageRestrictedTasks: updatedPageRestrictedTasks
            });
        },
    setParentSpaceRestrictedTasks: (tasks)=>({ setState: setState })=>{
            setState({
                parentSpaceRestrictedTasks: tasks
            });
        },
    addParentSpaceRestrictedTasks: (addedParentSpaceRestrictedTasks)=>({ setState: setState, getState: getState })=>{
            const { parentSpaceRestrictedTasks: parentSpaceRestrictedTasks } = getState();
            const updatedParentSpaceRestrictedTasks = [
                ...parentSpaceRestrictedTasks,
                ...addedParentSpaceRestrictedTasks
            ];
            setState({
                parentSpaceRestrictedTasks: updatedParentSpaceRestrictedTasks
            });
        },
    removeParentSpaceRestrictedTasks: (removedParentSpaceRestrictedTasks)=>({ setState: setState, getState: getState })=>{
            const removedLocalIds = new Set(removedParentSpaceRestrictedTasks.map((tasks)=>tasks.localId));
            const { parentSpaceRestrictedTasks: parentSpaceRestrictedTasks } = getState();
            const updatedParentSpaceRestrictedTasks = parentSpaceRestrictedTasks.filter((tasks)=>!removedLocalIds.has(tasks.localId));
            setState({
                parentSpaceRestrictedTasks: updatedParentSpaceRestrictedTasks
            });
        },
    setUnrestrictedTasks: (tasks)=>({ setState: setState })=>{
            setState({
                unrestrictedTasks: tasks
            });
        },
    addUnrestrictedTasks: (addedUnrestrictedTasks)=>({ setState: setState, getState: getState })=>{
            const { unrestrictedTasks: unrestrictedTasks } = getState();
            const updatedUnrestrictedTasks = [
                ...unrestrictedTasks,
                ...addedUnrestrictedTasks
            ];
            setState({
                unrestrictedTasks: updatedUnrestrictedTasks
            });
        },
    removeUnrestrictedTasks: (removedUnrestrictedTasks)=>({ setState: setState, getState: getState })=>{
            const removedLocalIds = new Set(removedUnrestrictedTasks.map((tasks)=>tasks.localId));
            const { unrestrictedTasks: unrestrictedTasks } = getState();
            const updatedUnrestrictedTasks = unrestrictedTasks.filter((tasks)=>!removedLocalIds.has(tasks.localId));
            setState({
                unrestrictedTasks: updatedUnrestrictedTasks
            });
        },
    setMentionsAdded: (mentionsToAdd)=>({ setState: setState, getState: getState })=>{
            const { mentionsAdded: mentionsAdded } = getState();
            const updatedMentionsAdded = mentionsAdded;
            if (mentionsToAdd.currentUser) {
                if (mentionsToAdd.currentUser.length > 0) {
                    const currentUserMentions = mentionsToAdd.currentUser;
                    updatedMentionsAdded.currentUser = [
                        ...currentUserMentions,
                        ...mentionsAdded.currentUser
                    ];
                } else updatedMentionsAdded.currentUser = [];
            }
            setState({
                mentionsAdded: updatedMentionsAdded
            });
        },
    setTasksAdded: (tasksToAdd)=>({ setState: setState, getState: getState })=>{
            const { tasksAdded: tasksAdded } = getState();
            const updatedTasksAdded = tasksAdded;
            if (tasksToAdd.currentUser) {
                if (tasksToAdd.currentUser.length > 0) {
                    const currentUserTasks = tasksToAdd.currentUser;
                    updatedTasksAdded.currentUser = [
                        ...currentUserTasks,
                        ...tasksAdded.currentUser
                    ];
                } else updatedTasksAdded.currentUser = [];
            }
            setState({
                tasksAdded: updatedTasksAdded
            });
        },
    clearMentionsFlags: ()=>({ setState: setState })=>{
            setState($2d2e882c9a90b3be$var$getInitialState());
        }
};
const $2d2e882c9a90b3be$var$MentionsNotificationsStore = (0, $8s9DV.createStore)({
    initialState: $2d2e882c9a90b3be$var$getInitialState(),
    actions: $2d2e882c9a90b3be$var$actions,
    name: 'MentionsNotificationsStore'
});
const $2d2e882c9a90b3be$export$63a7b4a5d3248013 = (0, $kBr4q.createHook)($2d2e882c9a90b3be$var$MentionsNotificationsStore);
const $2d2e882c9a90b3be$export$e03e9325d0a65293 = (0, $kBr4q.createActionsHook)($2d2e882c9a90b3be$var$MentionsNotificationsStore);
module.exports["useMentionsNotifications"] = $2d2e882c9a90b3be$export$63a7b4a5d3248013;
module.exports["useMentionsNotificationsActions"] = $2d2e882c9a90b3be$export$e03e9325d0a65293;

});

parcelRegister("cmBjr", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kyKWe = parcelRequire("kyKWe");


var $7aRa9 = parcelRequire("7aRa9");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $dPJCf = parcelRequire("dPJCf");


var $bqMNb = parcelRequire("bqMNb");


var $jv3O2 = parcelRequire("jv3O2");


var $i9VoI = parcelRequire("i9VoI");

const $1c71f3d63aae3f56$export$b0544c15da22323d = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    const showConvertToLivePageFlag = (0, $jv3O2.useShowConvertToLivePageFlag)({
        flags: flags
    });
    const onSubscriptionEvent = (0, $cozmU.useCallback)((response)=>{
        const { accountId: accountId, pageUpdated: pageUpdated } = response || {};
        const trigger = pageUpdated?.trigger;
        if (trigger !== 'convertToLiveEdit') return;
        showConvertToLivePageFlag({
            converterWasCurrentUser: accountId === userId
        });
        // When another user converts the page to a live doc, we need to add a query param to avoid the double action bar bug.
        // Without this, the page may read stale SSR values indicating it's not a live page, causing UI weirdness.
        // The query param forces RouteState to increment transitionId, preventing it from using initial SSR values.
        setQueryParams({
            [(0, $bqMNb.FORCE_TRANSITION_QUERY_PARAM)]: (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()
        });
    }, [
        showConvertToLivePageFlag,
        userId,
        setQueryParams
    ]);
    (0, $i9VoI.useSubscriptionEvent)({
        subscriberId: 'convertToLivePageFlag',
        contentId: contentId,
        delta: 'pageUpdated',
        contentType: 'page',
        skip: !contentId,
        onDataReceived: (response)=>onSubscriptionEvent(response)
    });
    return null;
});
module.exports["ConvertToLivePageFlag"] = $1c71f3d63aae3f56$export$b0544c15da22323d;

});

parcelRegister("fzhfU", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $JTIzG = parcelRequire("JTIzG");

const $e4992c54b0e0da53$export$ede5d3bbbf3ec238 = (0, $3u0dr.isReactCompilerActiveV2)() ? (isAIEnabledForContent)=>{
    const { isAIPolicyAndBrowserSupportEnabled: isAIPolicyAndBrowserSupportEnabled, isAudioBylineEntrypointEnabled: isAudioBylineEntrypointEnabled } = (0, $JTIzG.useAudioFeatureFlags)();
    return isAIEnabledForContent && isAIPolicyAndBrowserSupportEnabled && !isAudioBylineEntrypointEnabled;
} : (isAIEnabledForContent)=>{
    const { isAIPolicyAndBrowserSupportEnabled: isAIPolicyAndBrowserSupportEnabled, isAudioBylineEntrypointEnabled: isAudioBylineEntrypointEnabled } = (0, $JTIzG.useAudioFeatureFlags)();
    // Only show audio entrypoint in sidebar if:
    // 1. AI is Enabled for content
    // 2. AI Policy and browser support are enabled AND
    // 3. The when byline entrypoint is not enabled (ex: Audio V2 experience), the object sidebar will be the only audio entrypoint.
    return isAIEnabledForContent && isAIPolicyAndBrowserSupportEnabled && !isAudioBylineEntrypointEnabled;
};
module.exports["useHasAudioButton"] = $e4992c54b0e0da53$export$ede5d3bbbf3ec238;

});

parcelRegister("dJ5r4", function(module, exports) {
$parcel$export(module.exports, "ViewCommentShortcutListener", () => (parcelRequire("fPcdI")).ViewCommentShortcutListener);

var $fPcdI = parcelRequire("fPcdI");


});

parcelRegister("fPcdI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $fJCU9 = parcelRequire("fJCU9");


var $9DHhW = parcelRequire("9DHhW");


var $9FoVw = parcelRequire("9FoVw");


var $aHcFH = parcelRequire("aHcFH");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $liGyh = parcelRequire("liGyh");


var $dANtQ = parcelRequire("dANtQ");


var $9QIM2 = parcelRequire("9QIM2");


var $fNzRA = parcelRequire("fNzRA");


var $9jl6v = parcelRequire("9jl6v");


var $bSvtO = parcelRequire("bSvtO");


var $cMvMc = parcelRequire("cMvMc");


var $8aF6s = parcelRequire("8aF6s");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4EKKB = parcelRequire("4EKKB");


var $gtj7V = parcelRequire("gtj7V");


var $aJPUt = parcelRequire("aJPUt");


var $inDu6 = parcelRequire("inDu6");


var $6GD8y = parcelRequire("6GD8y");


var $gnkil = parcelRequire("gnkil");


var $gczDe = parcelRequire("gczDe");


var $3mVfX = parcelRequire("3mVfX");


var $aWwYt = parcelRequire("aWwYt");


var $jvYFk = parcelRequire("jvYFk");


var $9wGTI = parcelRequire("9wGTI");


var $cgy29 = parcelRequire("cgy29");


var $dkkKv = parcelRequire("dkkKv");


var $8i27m = parcelRequire("8i27m");


var $fHAwL = parcelRequire("fHAwL");


var $4L9ve = parcelRequire("4L9ve");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $izhdc = parcelRequire("izhdc");


var $gSkOQ = parcelRequire("gSkOQ");

const $c392465906bed01c$var$ViewCommentShortcutListenerComponent = ({ isFabricPage: isFabricPage, contentId: contentId, dialogs: dialogs })=>{
    const { navigateToInlineComment: navigateToInlineComment } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const { activeHighlight: activeHighlight } = (0, $9jl6v.useInlineCommentsContext)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { removeCommentQueryParams: removeCommentQueryParams } = (0, $liGyh.useInlineCommentQueryParams)();
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, commentsDataMap: legacyCommentsDataMap } = (0, $8i27m.useCommentsDataState)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    const commentsDataMap = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? processedCommentsData.commentsDataMap : legacyCommentsDataMap;
    const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
    const pageClass = (0, $9QIM2.usePageClass)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isNextCommentLoading, setIsNextCommentLoading] = (0, $cozmU.useState)(false);
    const [alreadyFetchedInitialData, setAlreadyFetchedInitialData] = (0, $cozmU.useState)(false);
    const [triggeredByUnreadKeyboardShortcut, setTriggeredByUnreadKeyboardShortcut] = (0, $cozmU.useState)(false);
    const [{ currentlyRenderedThreads: currentlyRenderedThreads, currentlySelectedThreadKey: currentlySelectedThreadKey }, { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey }] = (0, $3mVfX.useCommentsPanel)();
    // Track previous annotation for difference-based scrolling
    const previousAnnotationRef = (0, $cozmU.useRef)(undefined);
    // Update ref whenever activeHighlight changes
    (0, $cozmU.useEffect)(()=>{
        // Only update if there's a valid value (not empty string or null)
        if (activeHighlight) previousAnnotationRef.current = activeHighlight;
    }, [
        activeHighlight
    ]);
    const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = (0, $aWwYt.useObjectSidebarState)();
    const { expandCommentContainer: expandCommentContainer, setFooterEditorEntry: setFooterEditorEntry } = (0, $fNzRA.useObjectCommentDispatchContext)();
    const { expanded: expanded, isObjectCommentWrapperVisible: isObjectCommentWrapperVisible, footerEditorEntry: footerEditorEntry } = (0, $fNzRA.useObjectCommentContext)();
    const { addFooterCommentAdf: addFooterCommentAdf } = (0, $3mVfX.useCommentsPanelState)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId ?? '');
    const orderedActiveAnnotations = (0, $cozmU.useMemo)(()=>{
        return orderedActiveAnnotationIdList.map((a)=>a.threadKey);
    }, [
        orderedActiveAnnotationIdList
    ]);
    (0, $cozmU.useEffect)(()=>{
        setIsNextCommentLoading(false);
    }, [
        activeHighlight,
        currentlySelectedThreadKey
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            setCurrentlySelectedThreadKey('');
        };
    }, [
        setCurrentlySelectedThreadKey
    ]);
    const { footerCommentThreads: footerCommentThreads, footerCommentIds: footerCommentIds } = (0, $gSkOQ.useFooterComments)();
    const { unreadInlineComments: unreadInlineComments, unreadGeneralComments: unreadGeneralComments } = (0, $cozmU.useMemo)(()=>{
        const unreadInlineComments = [];
        const unreadGeneralComments = [];
        orderedActiveAnnotations.forEach((threadKey)=>{
            const commentData = commentsDataMap.inline[threadKey];
            if (commentData) {
                let isCommentUnread = false;
                let hasUnreadReplies = false;
                // Use unreadCommentIDSet when feature flag is enabled
                // in SSR, unreadCommentIDSet is undefined
                isCommentUnread = unreadCommentIDSet?.has(commentData.id);
                hasUnreadReplies = commentData.replies?.some((reply)=>reply && unreadCommentIDSet?.has(reply.id)) || false;
                if (isCommentUnread || hasUnreadReplies) unreadInlineComments.push(threadKey);
            }
        });
        Object.keys(commentsDataMap.general).forEach((threadKey)=>{
            const commentData = commentsDataMap.general[threadKey];
            if (commentData) {
                let isCommentUnread = false;
                let hasUnreadReplies = false;
                // Use unreadCommentIDSet when feature flag is enabled
                isCommentUnread = unreadCommentIDSet?.has(commentData.id);
                hasUnreadReplies = commentData.replies?.some((reply)=>reply && unreadCommentIDSet?.has(reply.id)) || false;
                if (isCommentUnread || hasUnreadReplies) unreadGeneralComments.push(threadKey);
            }
        });
        return {
            unreadInlineComments: unreadInlineComments,
            unreadGeneralComments: unreadGeneralComments
        };
    }, [
        commentsDataMap,
        orderedActiveAnnotations,
        unreadCommentIDSet
    ]);
    const sendKeyboardShortcutAnalytics = (shortcut)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'viewPage',
                action: 'pressed',
                actionSubject: 'keyboardShortcut',
                actionSubjectId: 'createComment',
                attributes: {
                    key: shortcut
                }
            }
        }).fire();
    };
    const { handleCommentButtonClick: handleCommentButtonClick } = (0, $cgy29.useCreateCommentAction)({
        contentId: contentId || '',
        isFabric: isFabricPage,
        sendKeyboardShortcutAnalytics: sendKeyboardShortcutAnalytics
    });
    const getCommentIndex = (0, $cozmU.useCallback)((currentThreadKey)=>{
        return [
            ...orderedActiveAnnotations,
            ...footerCommentIds
        ]?.findIndex((threadKey)=>threadKey === currentThreadKey);
    }, [
        orderedActiveAnnotations,
        footerCommentIds
    ]);
    const openInlineComment = (0, $cozmU.useCallback)((markerRef)=>{
        if (pageClass === 'renderer' || pageClass === 'editor') experienceTracker.start({
            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
            timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
            attributes: {
                ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                annotationId: markerRef,
                entryPoint: 'comments-shortcuts/ViewCommentShortcutListener',
                pageClass: 'renderer'
            }
        });
        const previousAnnotationId = previousAnnotationRef.current;
        setCurrentlySelectedThreadKey('');
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const commentElement = document.getElementById(markerRef);
        (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
            annotationId: markerRef
        });
        (0, $4EKKB.selectInlineComment).debug(`Keyboard selection now triggering annotation selection for annotation ${markerRef}`);
        emitter.emit((0, $fJCU9.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: [
                markerRef
            ],
            eventTarget: commentElement
        });
        (0, $9FoVw.handleKeyboardShortcutNavigation)({
            scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
            block: 'center',
            annotationId: markerRef,
            previousAnnotationId: previousAnnotationId,
            commentType: 'INLINE',
            isCommentsPanelOpen: isObjectSidebarShown,
            hasKeyPressed: true,
            context: (0, $9FoVw.NavigationContext).RENDERER
        });
    }, [
        emitter,
        setCurrentlySelectedThreadKey,
        experienceTracker,
        pageClass,
        isObjectSidebarShown
    ]);
    const scrollToFooterComment = (0, $cozmU.useCallback)((threadKey)=>{
        // Reset previous annotation ref when navigating to footer comment
        previousAnnotationRef.current = undefined;
        setCurrentlySelectedThreadKey(threadKey);
        emitter.emit((0, $fJCU9.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: [],
            eventTarget: null
        });
        (0, $9FoVw.handleKeyboardShortcutNavigation)({
            scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
            block: 'center',
            annotationId: threadKey,
            commentType: 'FOOTER',
            isCommentsPanelOpen: isObjectSidebarShown,
            hasKeyPressed: true
        });
    }, [
        emitter,
        setCurrentlySelectedThreadKey,
        isObjectSidebarShown
    ]);
    const onNavigationClick = (0, $cozmU.useCallback)((nextMarkerRef)=>{
        if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>{
                resetContentChanged();
                openInlineComment(nextMarkerRef);
            }
        });
        else openInlineComment(nextMarkerRef);
    }, [
        hasContentChanged,
        resetContentChanged,
        showModal,
        openInlineComment
    ]);
    const handlePanelCommentNavigation = (0, $cozmU.useCallback)((action)=>{
        // If nothing is on the panel, there's nothing to navigate to
        if (currentlyRenderedThreads.length === 0) return;
        const { panelCommentRefs: panelCommentRefs, navigableInlineCommentRefs: navigableInlineCommentRefs } = (0, $izhdc.parsePanelAndInlineRefs)(currentlyRenderedThreads, orderedActiveAnnotations);
        const nextRef = (0, $izhdc.getNextRef)(action, panelCommentRefs, currentlySelectedThreadKey);
        // Handle panel selection state management in the listener
        setCurrentlySelectedThreadKey(nextRef.ref);
        (0, $9FoVw.handleKeyboardShortcutNavigation)({
            scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
            block: 'center',
            annotationId: nextRef.ref,
            commentType: nextRef.type === (0, $8i27m.CommentType).GENERAL ? 'FOOTER' : 'INLINE',
            isCommentsPanelOpen: isObjectSidebarShown,
            hasKeyPressed: true,
            context: (0, $9FoVw.NavigationContext).RENDERER,
            isResolved: !navigableInlineCommentRefs.has(nextRef.ref)
        });
    }, [
        currentlyRenderedThreads,
        orderedActiveAnnotations,
        currentlySelectedThreadKey,
        setCurrentlySelectedThreadKey,
        isObjectSidebarShown
    ]);
    const handleNextCommentNavigation = (0, $cozmU.useCallback)(({ action: action, isNavigateToNextUnread: isNavigateToNextUnread })=>{
        //Check if the next inline comment is still in process of being rendered. Otherwise, quickly pressing keys will force comment to open and close instead of navigating
        if (isNextCommentLoading) return;
        setIsNextCommentLoading(true);
        navigateToInlineComment({
            action: action,
            triggeredByKeyboardShortcut: true,
            currentCommentIndex: getCommentIndex(activeHighlight || currentlySelectedThreadKey || ''),
            getCommentIndex: getCommentIndex,
            onNavigationClick: onNavigationClick,
            isEditor: false,
            removeCommentQueryParams: removeCommentQueryParams,
            unresolvedInlineComments: orderedActiveAnnotations,
            createAnalyticsEvent: createAnalyticsEvent,
            contentId: contentId,
            isNavigateToNextUnread: isNavigateToNextUnread,
            unreadInlineComments: unreadInlineComments,
            unreadGeneralComments: unreadGeneralComments,
            footerComments: footerCommentIds,
            scrollToFooterComment: scrollToFooterComment,
            commentsDataMap: commentsDataMap
        });
    }, [
        isNextCommentLoading,
        navigateToInlineComment,
        getCommentIndex,
        activeHighlight,
        currentlySelectedThreadKey,
        onNavigationClick,
        removeCommentQueryParams,
        orderedActiveAnnotations,
        createAnalyticsEvent,
        contentId,
        unreadInlineComments,
        unreadGeneralComments,
        footerCommentIds,
        scrollToFooterComment,
        commentsDataMap
    ]);
    const handleStandaloneCommentNavigation = (0, $cozmU.useCallback)((action)=>{
        if (activeHighlight || currentlySelectedThreadKey) handleNextCommentNavigation({
            isNavigateToNextUnread: false,
            action: action
        });
        else {
            // No highlight selected, so we navigate to the first inline comment
            const firstInlineCommentMarkerRef = orderedActiveAnnotations[0];
            if (!firstInlineCommentMarkerRef && footerCommentThreads.length === 0) return;
            if (firstInlineCommentMarkerRef) openInlineComment(firstInlineCommentMarkerRef);
            else scrollToFooterComment(footerCommentThreads[0]?.id);
        }
    }, [
        activeHighlight,
        currentlySelectedThreadKey,
        orderedActiveAnnotations,
        handleNextCommentNavigation,
        footerCommentThreads,
        openInlineComment,
        scrollToFooterComment
    ]);
    const handleCommentNavigation = (0, $cozmU.useCallback)((action)=>{
        // Define behavior when the comments panel is shown - panel FG is a prereq for nav, so has to be checked first
        if (isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel) handlePanelCommentNavigation(action);
        else // Comments panel not shown
        handleStandaloneCommentNavigation(action);
    }, [
        isObjectSidebarShown,
        panel?.id,
        handlePanelCommentNavigation,
        handleStandaloneCommentNavigation
    ]);
    (0, $dkkKv.useActiveCommentsQuery)({
        pageId: contentId || '',
        skip: !triggeredByUnreadKeyboardShortcut || alreadyFetchedInitialData || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false),
        onCompletedFn: ()=>{
            setAlreadyFetchedInitialData(true);
        }
    });
    const handleNextUnreadNavigation = (0, $cozmU.useCallback)(()=>{
        if (!alreadyFetchedInitialData) {
            //This will trigger the ActiveComments query if it's not already fetched
            setTriggeredByUnreadKeyboardShortcut(true);
            //Exit because the comment data won't be available yet to navigate to
            return;
        }
        //unread panel navigation
        if (isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel) {
            let nextThreadKey = '';
            let nextCommentType = (0, $8i27m.CommentType).GENERAL;
            if (!currentlySelectedThreadKey) {
                if (unreadInlineComments.length > 0) {
                    nextThreadKey = unreadInlineComments[0];
                    nextCommentType = (0, $8i27m.CommentType).INLINE;
                } else nextThreadKey = unreadGeneralComments[0];
            } else {
                nextThreadKey = (0, $aHcFH.getNextUnreadThreadKey)(getCommentIndex(currentlySelectedThreadKey ?? '') + 1, //Add one otherwise it might get stuck on the current comment because there are unread replies which are collapsed
                [
                    ...orderedActiveAnnotations,
                    ...footerCommentIds
                ], [
                    ...unreadInlineComments,
                    ...unreadGeneralComments
                ]) ?? '';
                if (unreadInlineComments.includes(nextThreadKey)) nextCommentType = (0, $8i27m.CommentType).INLINE;
            }
            // Handle panel selection state management in the listener
            setCurrentlySelectedThreadKey(nextThreadKey);
            (0, $9FoVw.handleKeyboardShortcutNavigation)({
                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                block: 'center',
                annotationId: nextThreadKey,
                commentType: nextCommentType === (0, $8i27m.CommentType).GENERAL ? 'FOOTER' : 'INLINE',
                isCommentsPanelOpen: isObjectSidebarShown,
                hasKeyPressed: true,
                context: (0, $9FoVw.NavigationContext).RENDERER,
                shortcutType: (0, $9FoVw.ShortcutType).UNREAD
            });
            return;
        }
        if (activeHighlight || currentlySelectedThreadKey) handleNextCommentNavigation({
            isNavigateToNextUnread: true,
            action: 'next'
        });
        else {
            if (unreadInlineComments.length + unreadGeneralComments.length === 0) return;
            if (unreadInlineComments[0]) openInlineComment(unreadInlineComments[0]);
            else scrollToFooterComment(unreadGeneralComments[0]);
        }
    }, [
        isObjectSidebarShown,
        panel?.id,
        handleNextCommentNavigation,
        unreadInlineComments,
        activeHighlight,
        openInlineComment,
        scrollToFooterComment,
        currentlySelectedThreadKey,
        unreadGeneralComments,
        footerCommentIds,
        getCommentIndex,
        orderedActiveAnnotations,
        setCurrentlySelectedThreadKey,
        alreadyFetchedInitialData
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (unreadInlineComments.length + unreadGeneralComments.length > 0 && alreadyFetchedInitialData && triggeredByUnreadKeyboardShortcut) {
            // This handles the case where user triggers unread keyboard shortcut when the comments data isn't fetched yet.
            // We need to wait for the data to be fetched before calling handleNextUnreadNavigation
            setTriggeredByUnreadKeyboardShortcut(false);
            // Putting this behind a timeout because need to wait for triggeredByUnreadKeyboardShortcut to be set to false otherwise got called multiple times
            setTimeout(()=>{
                handleNextUnreadNavigation();
            }, 100);
        }
    }, [
        unreadInlineComments,
        unreadGeneralComments,
        handleNextUnreadNavigation,
        alreadyFetchedInitialData,
        triggeredByUnreadKeyboardShortcut,
        setTriggeredByUnreadKeyboardShortcut
    ]);
    const openCommentEditorShortcutCb = (e)=>{
        e.preventDefault();
        // This check is necessary to see which keyboard shortcut was used so it can be sent to analytics.
        // e.key is used to get the key that was pressed according to the current keyboard layout.
        // We compare with CREATE_COMMENT_SHORTCUT because it is a single-letter keyboard shortcut.
        // It's more difficult to compare with UNIVERSAL_OPEN_COMMENT_EDITOR because it includes modifiers.  Modifiers which change what e.key maps to depending on the keyboard layout.
        const shortcut = e.key === (0, $gnkil.CREATE_COMMENT_SHORTCUT) ? (0, $gnkil.CREATE_COMMENT_SHORTCUT) : (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR);
        if (canAddComments || !(0, $9wGTI.fg)('confluence_fe_add_comment_kb_check_permission')) {
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            if (document.querySelector('[data-testid="highlightActionsPopup"]')) {
                // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                const createButton = document.querySelector('#create-inline-comment-button');
                // If createButton is not found or is disabled, do nothing.
                // This handles the case when hovering over media (image/video) objects in renderer.
                // In this scenario, a `highlightActionsPopup` is shown but the Comment button (which
                // has a different id) behaves differently: if any comment exists on the media object,
                // button click opens it as standalone; otherwise button click opens CreateComment.
                // Keyboard shortcut is disabled for this scenario.
                const createButtonIsEnabled = createButton && createButton?.getAttribute('disabled') !== '';
                if (createButtonIsEnabled) handleCommentButtonClick({
                    dialogs: dialogs,
                    shortcut: shortcut,
                    experienceAttributes: {
                        entryPoint: 'keyboardShortcut',
                        edition: edition
                    }
                });
            } else {
                // Check if we should show sticky draft instead of scrolling to object comment wrapper
                const isShowStickyDraft = !isObjectCommentWrapperVisible && (addFooterCommentAdf || expanded) && footerEditorEntry !== (0, $fNzRA.AddFooterCommentMode).STICKY_DRAFT;
                if (!expanded) expandCommentContainer({
                    entryPoint: 'keyboardShortcutView'
                });
                if (isShowStickyDraft || !isObjectCommentWrapperVisible) setFooterEditorEntry((0, $fNzRA.AddFooterCommentMode).STICKY_DRAFT);
                else // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                document.querySelector(`[data-testid='object-comment-wrapper']`)?.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        }
        sendKeyboardShortcutAnalytics(shortcut);
    };
    if (!isFabricPage) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "comments-shortcut-listener"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_SELECT_COMMENT_SHORTCUT),
        listener: ()=>{
            const openComment = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            document.getElementById('renderer-comments-sidebar') || // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            document.getElementById(`comment-thread-${currentlySelectedThreadKey}-container`);
            if (openComment) (0, $aHcFH.focusElementAndUpdateTabIndex)(openComment);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_NEXT_COMMENT_SHORTCUT),
        deprecatedAccelerator: (0, $gnkil.NEXT_COMMENT_SHORTCUT),
        listener: ()=>{
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: 'keyboard-navigation'
            });
            (0, $4EKKB.selectInlineComment).debug('keyboard navigation to next comment', {
                // whenTriggered props added to help debug on Hello (for reproducing issues)
                activeHighlightWhenTriggered: activeHighlight,
                currentlySelectedThreadKeyWhenTriggered: currentlySelectedThreadKey
            });
            handleCommentNavigation('next');
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_PREV_COMMENT_SHORTCUT),
        deprecatedAccelerator: (0, $gnkil.PREV_COMMENT_SHORTCUT),
        listener: ()=>{
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: 'keyboard-navigation'
            });
            (0, $4EKKB.selectInlineComment).debug('keyboard navigation to previous comment', {
                // whenTriggered props added to help debug on Hello (for reproducing issues)
                activeHighlightWhenTriggered: activeHighlight,
                currentlySelectedThreadKeyWhenTriggered: currentlySelectedThreadKey
            });
            handleCommentNavigation('previous');
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_NEXT_UNREAD_COMMENT_SHORTCUT),
        listener: ()=>{
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: 'keyboard-navigation'
            });
            (0, $4EKKB.selectInlineComment).debug('Keyboard navigation to next unread comment', {
                // whenTriggered props added to help debug on Hello (for reproducing issues)
                activeHighlightWhenTriggered: activeHighlight,
                currentlySelectedThreadKeyWhenTriggered: currentlySelectedThreadKey
            });
            handleNextUnreadNavigation();
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: (0, $gnkil.CREATE_COMMENT_SHORTCUT),
        accelerator: (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR),
        listener: (e)=>openCommentEditorShortcutCb(e)
    }));
};
const $c392465906bed01c$export$c1f9f1253d923bc1 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).COMMENTS
})((0, $inDu6.withDialogs)($c392465906bed01c$var$ViewCommentShortcutListenerComponent));
module.exports["ViewCommentShortcutListener"] = $c392465906bed01c$export$c1f9f1253d923bc1;

});

parcelRegister("39nIX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");

var $398ES = parcelRequire("398ES");


var $7boqA = parcelRequire("7boqA");


var $5RuD9 = parcelRequire("5RuD9");


var $jhifQ = parcelRequire("jhifQ");


/* View Mode Exports */ const $166368e9a123fc4e$var$InlineCommentsLoaderPaint = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "fZs06",
    name: "InlineCommentsLoaderPaint",
    loader: async ()=>(await (parcelRequire("jQsWL"))).InlineComments,
    loading: (0, $5RuD9.InlineCommentsLoading)
});

const $166368e9a123fc4e$var$InlineCommentsLoaderLazy = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "i8DIK",
    name: "InlineCommentsLoaderLazy",
    loader: async ()=>(await (parcelRequire("jQsWL"))).InlineComments,
    loading: (0, $5RuD9.InlineCommentsLoading)
});

const $166368e9a123fc4e$var$InlineCommentsLoaderAfterPaint = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "vilgC",
    name: "InlineCommentsLoaderAfterPaint",
    loader: async ()=>(await (parcelRequire("jQsWL"))).InlineComments
});

const $166368e9a123fc4e$var$InlineCommentsLoaderBackground = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "05zPo",
    name: "InlineCommentsLoaderBackground",
    loader: async ()=>(await (parcelRequire("jQsWL"))).InlineComments
});
const $166368e9a123fc4e$var$loaders = {
    [(0, $398ES.LoadingPriority).LAZY]: $166368e9a123fc4e$var$InlineCommentsLoaderLazy,
    [(0, $398ES.LoadingPriority).PAINT]: $166368e9a123fc4e$var$InlineCommentsLoaderPaint,
    [(0, $398ES.LoadingPriority).AFTER_PAINT]: $166368e9a123fc4e$var$InlineCommentsLoaderAfterPaint
};
const $166368e9a123fc4e$export$bceb71dc98e1c75f = ({ loadingPriority: loadingPriority, focusedCommentId: focusedCommentId, ...rest })=>{
    const CommentsLoader = $166368e9a123fc4e$var$loaders[loadingPriority] || $166368e9a123fc4e$var$InlineCommentsLoaderBackground;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, focusedCommentId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
        key: `start-${focusedCommentId}`,
        metric: (0, $jhifQ.FOCUSED_INLINE_COMMENT_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(CommentsLoader, rest));
};
module.exports["InlineCommentsLoader"] = $166368e9a123fc4e$export$bceb71dc98e1c75f;

});

parcelRegister("5RuD9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8uhVX = parcelRequire("8uhVX");


var $beAZw = parcelRequire("beAZw");

const $58d1b0f1d68392b5$var$checkForSSRFocusedComment = ()=>{
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) return true;
    return false;
};
const $58d1b0f1d68392b5$export$d174da0f28ffce9e = ()=>{
    return $58d1b0f1d68392b5$var$checkForSSRFocusedComment() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8uhVX.FocusedInlineComment), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $beAZw.InlineCommentsLoadingSkeleton), null);
};
module.exports["InlineCommentsLoading"] = $58d1b0f1d68392b5$export$d174da0f28ffce9e;

});

parcelRegister("8uhVX", function(module, exports) {
/* FocusedInlineComment.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $9wGTI = parcelRequire("9wGTI");


var $dOBRD = parcelRequire("dOBRD");


var $kSwu1 = parcelRequire("kSwu1");


var $jMyy4 = parcelRequire("jMyy4");


var $7zgzO = parcelRequire("7zgzO");


var $ep3mz = parcelRequire("ep3mz");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");




var $9CnRS = parcelRequire("9CnRS");


var $666Tc = parcelRequire("666Tc");


var $k5dl6 = parcelRequire("k5dl6");



var $f8HSn = parcelRequire("f8HSn");


var $qYtBT = parcelRequire("qYtBT");


var $dQJV7 = parcelRequire("dQJV7");


var $c04ej = parcelRequire("c04ej");

const $d9a6205ec51ab13a$var$parseContent = (0, $dOBRD.default)((content)=>{
    if (!content?.length) return null;
    try {
        return JSON.parse(content);
    } catch  {
        return null;
    }
});
const $d9a6205ec51ab13a$var$FocusedInlineCommentContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = (0, $666Tc.SidebarContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_162hus6": (0, $9aYkv.default)(__cmplp.offset, "px")
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_154i1odf _zqk2124n _16tr13gf",
            __cmplp.showSkeleton ? "_1e0c1ule" : "_1e0cglyw",
            __cmplp.className
        ])
    });
}); /* Comment Editor CSS*/ 
const $d9a6205ec51ab13a$var$EditorContainerSSRFallback = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = (0, $666Tc.EditorContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_10v51b66 _1fnwia51 _116r1l7b _kv9qfhey _12i31ul9 _j980usvi _1esn1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $d9a6205ec51ab13a$var$EditorContainerSSRTokenized = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = (0, $666Tc.EditorContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_10v51b66 _1fnwia51 _116r12b0 _kv9qfhey _12i31ul9 _j980usvi _1esn1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $d9a6205ec51ab13a$var$CommentContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFocused: isFocused, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yt49l6b _12ji1r31 _1qu2glyw _12y31o36 _1kl7idpf _x3doidpf _1e0c1txw _2lx21bp4 _1ragidpf _ha8hi7uo",
            __cmplp.isFocused && "_11q71856",
            __cmplp.className
        ])
    });
});
const $d9a6205ec51ab13a$export$622cea445a1c5b7d = ()=>{
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) return window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['markerRefOffset'];
    return 0;
}; // Makes sure to only show focusedInlineCommentSSR if the page was ssr'd
const $d9a6205ec51ab13a$export$db871669e60ed1cb = ()=>{
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) return true;
    return false;
};
const $d9a6205ec51ab13a$export$7afb8d400fcdf579 = ()=>{
    const EditorContainerSSR = (0, $9wGTI.fg)('confluence_frontend_tokenize_border') ? $d9a6205ec51ab13a$var$EditorContainerSSRTokenized : $d9a6205ec51ab13a$var$EditorContainerSSRFallback;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { match: match } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const focusedCommentId = match?.query.focusedCommentId;
    const focusedCommentIdString = typeof focusedCommentId === 'string' ? focusedCommentId : ''; // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $k5dl6.default), {
        variables: {
            commentId: focusedCommentIdString,
            contentId: contentId
        },
        skip: !(contentId && focusedCommentId),
        __callerPackage__: "inline-comments"
    });
    let commentData;
    let isTopLevelComment = true; /* If focusedCommentId is a reply grab top-level comment Data from ancestors.
                                 If ancestors is non-empty it means focusedCommentId is a reply*/ 
    if (data?.comments?.nodes?.[0]?.ancestors && data.comments.nodes[0].ancestors.length > 0) {
        commentData = data.comments.nodes[0].ancestors[0];
        isTopLevelComment = false;
    } else commentData = data?.comments?.nodes?.[0];
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['isTopLevelComment'] = isTopLevelComment;
    const content = data?.content?.nodes?.[0];
    const operations = content?.operations || [];
    const canCreateComments = Boolean(operations.find((op)=>op?.operation === 'create' && op?.targetType === 'comment'));
    const topCommentUserId = commentData?.author?.accountId;
    const topCommentUserAvatar = commentData?.author?.profilePicture?.path;
    const topCommentDisplayName = commentData?.author?.displayName;
    const commentId = commentData?.id;
    const when = commentData?.version?.when;
    const commentContent = commentData?.body?.value;
    const permissionType = commentData?.author?.permissionType;
    const currentUserAvatarUrl = data?.user?.photos?.[0]?.value ?? undefined;
    const currentUserDisplayName = data?.user?.displayName ?? undefined;
    const currentUserId = data?.user?.id;
    const adf = $d9a6205ec51ab13a$var$parseContent(commentContent);
    const renderReplies = ()=>{
        const replies = commentData?.replies || [];
        return replies.map((reply)=>{
            const adf = $d9a6205ec51ab13a$var$parseContent(reply?.body?.value);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d9a6205ec51ab13a$var$CommentContainer, {
                key: reply?.id,
                isFocused: focusedCommentId === reply?.id,
                "data-comment-id": reply?.id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f8HSn.CommentAuthor), {
                commentMode: "view",
                userId: reply?.author?.accountId,
                avatarUrl: reply?.author?.profilePicture?.path,
                displayName: reply?.author?.displayName,
                date: reply?.version?.when,
                permissionType: reply?.author?.permissionType
            }), adf && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c04ej.CommentRenderer), {
                adf: adf
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQJV7.CommentActions), {
                isReply: true,
                permissions: reply?.permissions
            }));
        });
    }; // Scroll to focusedInlineComment if it's out of the screen
    const scrollOffset = window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment'] && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['scrollOffset'];
    if (scrollOffset) window.scrollTo({
        top: scrollOffset
    });
    if (data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).COLLABORATION
    }, undefined, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d9a6205ec51ab13a$var$FocusedInlineCommentContainer, {
        mode: "view",
        id: "focused-inline-comment-sidebar-skeleton",
        "data-testid": "focused-inline-comment-sidebar-skeleton",
        showSkeleton: $d9a6205ec51ab13a$export$db871669e60ed1cb(),
        offset: $d9a6205ec51ab13a$export$622cea445a1c5b7d()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $qYtBT.CommentHeader), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d9a6205ec51ab13a$var$CommentContainer, {
        tabIndex: -1,
        "data-comment-id": commentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f8HSn.CommentAuthor), {
        commentMode: "view",
        userId: topCommentUserId,
        avatarUrl: topCommentUserAvatar,
        displayName: topCommentDisplayName,
        date: when,
        permissionType: permissionType,
        size: "medium"
    }), adf && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c04ej.CommentRenderer), {
        adf: adf
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQJV7.CommentActions), {
        permissions: commentData?.permissions,
        isReply: false
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $666Tc.ReplyListContainer), {
        "data-testid": "reply-container"
    }, renderReplies()), canCreateComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $666Tc.NewReplyContainer), {
        mode: "view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(EditorContainerSSR, {
        isReply: true,
        mode: "view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f8HSn.CommentAuthor), {
        commentMode: "reply",
        userId: currentUserId,
        avatarUrl: currentUserAvatarUrl,
        displayName: currentUserDisplayName,
        date: when,
        permissionType: permissionType,
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
        disabled: true,
        placeholder: formatMessage((0, $9CnRS.i18n).replyPlaceholder),
        "aria-label": formatMessage((0, $9CnRS.i18n).replyPlaceholder)
    })))), undefined);
    return null;
};
module.exports["FocusedInlineComment"] = $d9a6205ec51ab13a$export$7afb8d400fcdf579;

});

parcelRegister("f8HSn", function(module, exports) {
/* CommentAuthor.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $fs6LW = parcelRequire("fs6LW");


var $gvWVt = parcelRequire("gvWVt");


var $1YXTQ = parcelRequire("1YXTQ");


var $7tI6B = parcelRequire("7tI6B");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0598b16360d1677$var$DateContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2lx2vrvc _1n261q9c _1e0c1txw _4cvr1h6o _102ewadc _1mil78py _7wy0glyw _1t4pd34b _1plv1j28 _zmp8d34b _9b8id34b _1blwd34b",
            __cmplp.className
        ])
    });
});
const $b0598b16360d1677$var$AuthorContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { commentMode: commentMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw _4cvr1h6o _uvzw1snc _12rjagmp _1vjrvv82 _1dtc4viv _jva41snc _wkreagmp _gcmzvv82 _5xy14viv _1msj4viv",
            __cmplp.commentMode !== 'reply' ? "_18u01i6y" : "_18u01kw7",
            __cmplp.commentMode === 'view' && "_n3tdu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0598b16360d1677$var$AvatarWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { commentMode: commentMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw _u5f3u2gc",
            __cmplp.commentMode === 'view' && "_4t3i1wpv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0598b16360d1677$var$Container = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0598b16360d1677$var$ProfileLinkContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _2lx2vrvc _4cvr1h6o _17rpwadc _cpznidpf _1s79idpf _amufidpf _x966idpf _387xglyw _14l5d34b _1ptk1j28 _19gdazsu _1e6pazsu _1gidazsu _zer61snc _7ec9agmp _1bkkvv82 _z01g4viv _101q1snc _vnv1agmp _94evvv82 _kvyv4viv _18t3x3d0 _1t4p4viv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0598b16360d1677$var$LozengeWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_19bvu2gc _s7n4jp4b",
            __cmplp.className
        ])
    });
});
const $b0598b16360d1677$export$d05a2f5fbf67a6d7 = ({ commentMode: commentMode, userId: userId, date: date, displayName: displayName, avatarUrl: avatarUrl, permissionType: permissionType, size: size })=>{
    const isDateShown = commentMode === 'view' && date;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0598b16360d1677$var$AuthorContainer, {
        commentMode: commentMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0598b16360d1677$var$AvatarWrapper, {
        commentMode: commentMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fs6LW.ProfileAvatar), {
        userId: userId,
        src: avatarUrl,
        size: size,
        trigger: "click",
        name: displayName
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0598b16360d1677$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0598b16360d1677$var$ProfileLinkContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, displayName), permissionType === (0, $7tI6B.SitePermissionType).EXTERNAL ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0598b16360d1677$var$LozengeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gvWVt.ExternalCollaboratorUserLozenge), null)) : null), isDateShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0598b16360d1677$var$DateContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1YXTQ.TimeAgo), {
        date: date
    })))));
};
module.exports["CommentAuthor"] = $b0598b16360d1677$export$d05a2f5fbf67a6d7;

});

parcelRegister("qYtBT", function(module, exports) {
/* CommentHeader.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $l3wuH = parcelRequire("l3wuH");


var $6TaGl = parcelRequire("6TaGl");


var $7N1sB = parcelRequire("7N1sB");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9359cd91b07ea16f$var$SidebarHeader = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yt4ba4q _kqswh2mm _1e0c1txw _4t3i10yn _ca0qutpp _1hadu49m _wzsr12b0 _brspgktf _11pzgktf _p7gl1wug _1p0qutpp _etmr1b66 _13yvyfq0",
            __cmplp.className
        ])
    });
});
const $9359cd91b07ea16f$export$af4e8b81cdb5570a = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9359cd91b07ea16f$var$SidebarHeader, {
        "data-testid": "inline-comment-ssr-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7N1sB.CommentNavigation), {
        goToNextInlineComment: ()=>{},
        goToPrevInlineComment: ()=>{}
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        id: "dropdown"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
        label: "overflow-menu-icon",
        color: "var(--ds-icon-disabled, #080F214A)",
        spacing: "spacious"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        id: "close-icon-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
        label: "close-icon",
        color: `${"var(--ds-icon-disabled, #080F214A)"}`,
        spacing: "none"
    })));
};
module.exports["CommentHeader"] = $9359cd91b07ea16f$export$af4e8b81cdb5570a;

});

parcelRegister("dQJV7", function(module, exports) {
/* CommentActions.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $bFPHx = parcelRequire("bFPHx");


var $666Tc = parcelRequire("666Tc");


var $9CnRS = parcelRequire("9CnRS");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e6040be4eb93366f$var$ActionsContainerSSR = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = (0, $666Tc.ActionsContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1tke10yn _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $e6040be4eb93366f$var$ActionItem = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2lx2vrvc _1n261q9c _1e0c116y _syaz1rpy _19pk1b66 _xrwlcs5v _144bkb7n _14p1f1ug _ekv6wadc _6wjiesu3 _43ds1oa5 _1pzmusic _ep9t1b66 _1tzjf4df _8bo21mp2 _nqnu1rpy _d32v1rpy",
            __cmplp.className
        ])
    });
});
const $e6040be4eb93366f$var$ActionButton = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_11q7glyw _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _12ji1r31 _1qu21kw7 _12y31o36 _syaz1kw7 _1wyb1kw7 _80omtlke",
            __cmplp.className
        ])
    });
});
const $e6040be4eb93366f$export$e75a036919cd8d68 = ({ isReply: isReply, permissions: permissions })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e6040be4eb93366f$var$ActionsContainerSSR, null, permissions.isResolvable && !isReply && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e6040be4eb93366f$var$ActionItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e6040be4eb93366f$var$ActionButton, {
        type: "button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9CnRS.i18n).resolve))), permissions.isEditable && isReply && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e6040be4eb93366f$var$ActionItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e6040be4eb93366f$var$ActionButton, {
        type: "button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9CnRS.i18n).edit))), permissions.isRemovable && isReply && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e6040be4eb93366f$var$ActionItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e6040be4eb93366f$var$ActionButton, {
        type: "button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9CnRS.i18n).delete))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e6040be4eb93366f$var$ActionItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bFPHx.ReactionsPlaceholder), null)));
module.exports["CommentActions"] = $e6040be4eb93366f$export$e75a036919cd8d68;

});

parcelRegister("c04ej", function(module, exports) {
/* CommentRenderer.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $bzqa9 = parcelRequire("bzqa9");


var $hEeUR = parcelRequire("hEeUR");


var $6mKj3 = parcelRequire("6mKj3");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $61a27fe9845a1cb4$var$CommentRendererContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1reo15vq _18m915vq _ca0qutpp _n3tdutpp",
            __cmplp.className
        ])
    });
});
const $61a27fe9845a1cb4$export$ce6d3ea87eba7794 = ({ adf: adf })=>{
    const eventHandlers = (0, $bzqa9.useEventHandlers)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($61a27fe9845a1cb4$var$CommentRendererContainer, {
        id: "ssr-comment-renderer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hEeUR.ADFRenderer), {
        document: adf,
        appearance: "comment",
        eventHandlers: eventHandlers,
        ...(0, $6mKj3.expValEquals)('confluence_comments_media_ssr_support', 'isEnabled', true) && {
            media: undefined
        }
    }));
};
module.exports["CommentRenderer"] = $61a27fe9845a1cb4$export$ce6d3ea87eba7794;

});

parcelRegister("beAZw", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $rVJpV = parcelRequire("rVJpV");


var $666Tc = parcelRequire("666Tc");

const $c9d0ea73f4f989e9$export$bb9f90f28a3a4c80 = ()=>{
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['clickedInlineHighlightElements'] && Array.isArray(window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['clickedInlineHighlightElements'])) return Boolean(window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['clickedInlineHighlightElements'].length);
    return false;
};
const $c9d0ea73f4f989e9$export$e90f33bd7f6da077 = ({ offset: offset = 0 })=>{
    /* For SSR check window object or use offset if passed */ // Previously, clicking on a comment via the inline comment button would still generate an offset.
    // That meant that on transitions, the loading skeleton would still flicker, so we check for window.__SSR_RENDERED__ as well
    /// to prevent the flicker on transitions.
    const sideBarOffset = window.__SSR_RENDERED__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['sidebarCommentOffset'] || offset;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $666Tc.LoadingSkeletonContainer), {
        id: "inline-comment-sidebar-skeleton",
        "data-testid": "inline-comment-sidebar-skeleton",
        showSkeleton: $c9d0ea73f4f989e9$export$bb9f90f28a3a4c80() || Boolean(offset),
        offset: sideBarOffset,
        mode: "view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $rVJpV.LoadingSkeletonChildren), null));
};
module.exports["InlineCommentsLoadingSkeleton"] = $c9d0ea73f4f989e9$export$e90f33bd7f6da077;

});

parcelRegister("rVJpV", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $7sJoX = parcelRequire("7sJoX");


var $j6vyT = parcelRequire("j6vyT");


var $lfoFx = parcelRequire("lfoFx");


var $l3wuH = parcelRequire("l3wuH");


var $6TaGl = parcelRequire("6TaGl");


var $666Tc = parcelRequire("666Tc");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5ae94c9feb318d8$var$SkeletonContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1yt4pxbi _16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5ae94c9feb318d8$var$CommentSkeletonRow = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { flex: flex, useColumnDirection: useColumnDirection, marginTop: marginTop, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_flb7sw": (0, $9aYkv.default)(__cmplp.flex),
                "--_11vu6jx": (0, $9aYkv.default)(__cmplp.marginTop, "px")
            },
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_1e0c1txw _19pk4hp3",
                __cmplp.flex ? "_kkes1ubm" : "_16jlkb7n _1o9zkb7n _i0dlf1ug",
                __cmplp.useColumnDirection ? "_2lx21bp4" : "_2lx2vrvc",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $f5ae94c9feb318d8$var$CommentAuthorSkeleton = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2rko1rr0 _4t3izwfg _1bsbzwfg _bfhkizff",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5ae94c9feb318d8$var$CommentSkeletonLine = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { marginBottom: marginBottom, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_iz5w78": (0, $9aYkv.default)(__cmplp.marginBottom, "px"),
                "--_10ib6lf": (0, $9aYkv.default)(__cmplp.height, "px"),
                "--_1gljcou": (0, $9aYkv.default)(__cmplp.width, "px")
            },
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_2rko1l7b _bfhkizff _1bsb1rkg",
                typeof __cmplp.marginBottom === "number" ? "_otyr1s4l" : "_otyrrdoj",
                __cmplp.height ? "_4t3it1jn" : "_4t3iftgi",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $f5ae94c9feb318d8$var$SpinnerContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _19pku2gc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5ae94c9feb318d8$var$SidebarHeader = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1yt41fsj _kqswh2mm _1e0c1txw _1bah1yb4 _4t3i10yn",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f5ae94c9feb318d8$var$CloseButton = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $666Tc.InlineHeaderButton) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u014y2 _4t3i1tcg _1bsb1tcg",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f5ae94c9feb318d8$var$NavContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $666Tc.NavigationContainer) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f5ae94c9feb318d8$export$4857ba7068d0bed8 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_19pkidpf _otyridpf _kqswh2mm _bfhkvuon",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f5ae94c9feb318d8$export$a42ae5e40534ea56 = ()=>{
    const $ = (0, $bDgLe.c)(7);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $666Tc.InlineHeaderButton), {
            "data-cy": "inline-nav-previous",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
                label: "",
                color: "var(--ds-icon-disabled, #080F214A)",
                spacing: "spacious",
                size: "small"
            })
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$NavContainer, null, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $666Tc.InlineHeaderButton), {
            "data-cy": "inline-nav-previous",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                label: "",
                color: "var(--ds-icon-disabled, #080F214A)",
                spacing: "spacious",
                size: "small"
            })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$CommentSkeletonLine, {
            width: 30,
            height: 8,
            marginBottom: 0
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
            spacing: "spacious",
            label: "",
            color: "var(--ds-icon-disabled, #080F214A)"
        });
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$SidebarHeader, null, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$NavContainer, null, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$CloseButton, {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                label: ""
            })
        })));
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$CommentSkeletonRow, {
            flex: 1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$CommentAuthorSkeleton, null));
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$export$4857ba7068d0bed8, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$SkeletonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$CommentSkeletonRow, {
            flex: 1
        }, t4, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$CommentSkeletonRow, {
            flex: 5,
            marginTop: 5,
            useColumnDirection: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$CommentSkeletonLine, {
            width: 81
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$CommentSkeletonLine, {
            width: 53,
            height: 6
        })))));
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, t3, t5, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: "medium",
            interactionName: "inline-comments-loading-skeleton"
        })));
        $[6] = t6;
    } else t6 = $[6];
    return t6;
};
module.exports["LoadingSkeletonChildren"] = $f5ae94c9feb318d8$export$a42ae5e40534ea56;

});

parcelRegister("jQsWL", function(module, exports) {

let $e72953e5fe161080$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e72953e5fe161080$var$load("8GHVf"),
    $e72953e5fe161080$var$load("5Y1Vv"),
    $e72953e5fe161080$var$load("8DmEN"),
    $e72953e5fe161080$var$load("6wr18"),
    $e72953e5fe161080$var$load("lK9vp"),
    $e72953e5fe161080$var$load("agdLZ"),
    $e72953e5fe161080$var$load("kxG0W"),
    $e72953e5fe161080$var$load("byAMe"),
    $e72953e5fe161080$var$load("cKqFC"),
    $e72953e5fe161080$var$load("7k0CW"),
    $e72953e5fe161080$var$load("Wowvf"),
    $e72953e5fe161080$var$load("3zT1X"),
    $e72953e5fe161080$var$load("4W6oq"),
    $e72953e5fe161080$var$load("jqoep"),
    $e72953e5fe161080$var$load("7EorR"),
    $e72953e5fe161080$var$load("ffEVr"),
    $e72953e5fe161080$var$load("c6tdq"),
    $e72953e5fe161080$var$load("8CGdM"),
    $e72953e5fe161080$var$load("gzrfp"),
    $e72953e5fe161080$var$load("79Tk4"),
    $e72953e5fe161080$var$load("awFK7"),
    $e72953e5fe161080$var$load("5B6cE"),
    $e72953e5fe161080$var$load("1PFZq")
]).then(()=>parcelRequire('31yzi'));

});


//# sourceMappingURL=SpaceOverview.f8fab74f.js.map
